// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:47:42.485Z
// Property: Franklin Commons Apartments (ID: 6767906449166317)
// Collections: 32 amenities, 12 floorplans (live), 36 photos, 77 POIs, 8 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166317",
  "property_external_id": "615",
  "property_zillow_url": "https://www.zillow.com/apartments/bensalem-pa/franklin-commons/5XjQk8/",
  "property_apartments_url": "https://www.apartments.com/franklin-commons-bensalem-pa/5zqn6tq/",
  "property_google_business_url": "https://www.google.com/maps/place/Franklin+Commons+Apartment+Homes/data=!4m2!3m1!1s0x0:0xd7f947d92231683b?sa=X&ved=2ahUKEwiyjeb1nriSAxVGIEQIHXqoCaQQ_BJ6BAgvEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "franklin-commons-apartments",
  "property_name": "Franklin Commons Apartments",
  "property_website_url": "https://www.livefranklincommons.com/",
  "property_domain": "https://www.livefranklincommons.com/",
  "property_address": "1400 Cardinal Drive",
  "property_full_address": "1400 Cardinal Dr, Bensalem, PA 19020",
  "property_address_1": "1400 Cardinal Dr",
  "property_address_2": null,
  "property_address_city": "Bensalem",
  "property_address_state": "PA",
  "property_address_zip_full": "19020",
  "property_address_zip": "19020",
  "property_address_country": "US",
  "property_address_county": "Bucks County",
  "property_neighborhood_address": "Bensalem",
  "property_address_latitude": "40.1011645",
  "property_address_longitude": "-74.9345283",
  "property_email": "franklincommons@aionmanagement.com",
  "property_phone": "(215) 639-8400",
  "property_call_tracking_phone": "855-859-9122",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Franklin Commons Apartments in Bensalem, PA, modern living meets community spirit. Choose from stylish one or two-bedroom floor plans and enjoy amenities like a fitness center, serene dog park, and vibrant resident activities. Experience the perfect blend of comfort and convenience—your new home awaits! Schedule a tour today!",
  "property_long_description": "Welcome to Franklin Commons Apartments in the heart of Bensalem, PA, where modern living meets unparalleled community amenities! Our thoughtfully designed one- and two-bedroom floor plans ensure that you find the perfect space to call home. Each apartment features modern white cabinets, vinyl plank flooring, and wall-to-wall carpeting, offering both style and comfort.\n\nAt Franklin Commons, we believe in fostering a vibrant community atmosphere. Enjoy our extensive amenities, including a state-of-the-art fitness center, refreshing swimming pool, and playful dog park. You can also gather with friends and family at our grilling stations, fire pit, or picnic area—perfect for those warm summer evenings. Residents will appreciate our bilingual property team, 24-hour emergency maintenance, and the convenience of an online resident portal.\n\nOur community encourages engagement with organized resident activities, a game room, and a spacious clubhouse, ensuring there’s always something to do. Working from home is a breeze with our business center and conference room, while flexible rent payments offer peace of mind. \n\nEnjoy hassle-free living with on-site parking, off-street options, and easy access to public transportation for commuting convenience. Franklin Commons Apartments is pet-friendly and offers short-term leases to fit your lifestyle. Don’t miss out on your chance to experience the best of apartment living in Bensalem.\n\nFind your new home today—browse our availability or schedule a tour to visit our community! Discover the lifestyle you deserve at Franklin Commons Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd955-38c9-701f-8556-e7120d1a6bbb.webp",
  "property_featured_image_media": {
    "alt_text": "Patio with fire pit, seating, and tables outside community building.",
    "public_id": "019fd955-38c9-701f-8556-e7120d1a6bbb",
    "storage_key": "property/6767906449166317/019fd955-38c9-701f-8556-e7120d1a6bbb.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "703",
  "property_year_built": "1969",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.15504978662874",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Two pets maximum. AION does not have weight restrictions. Dogs, cats, and service animals are allowed (must be housebroken; no breeding).",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350, and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://franklincommons.loftliving.com/login",
  "property_apply_now_url": "https://www.livefranklincommons.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0264-85d7-736f-a031-ebd6152f2a3c.webp",
  "property_primary_logo_media": {
    "alt_text": "Franklin Commons logo with a stylized tree above the name.",
    "public_id": "019d0264-85d7-736f-a031-ebd6152f2a3c",
    "storage_key": "property/6767906449166317/019d0264-85d7-736f-a031-ebd6152f2a3c.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-96d0-71e9-a6a0-452b6675e7d8.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d0267-96d0-71e9-a6a0-452b6675e7d8",
    "storage_key": "property/6767906449166317/019d0267-96d0-71e9-a6a0-452b6675e7d8.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-a844-77fa-867e-7dff32d4fde5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Franklin Commons logo with a stylized tree above the text.",
    "public_id": "019d0267-a844-77fa-867e-7dff32d4fde5",
    "storage_key": "property/6767906449166317/019d0267-a844-77fa-867e-7dff32d4fde5.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0267-b6c8-7065-b1ba-180bbe13ab01.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Franklin Commons logo",
    "public_id": "019d0267-b6c8-7065-b1ba-180bbe13ab01",
    "storage_key": "property/6767906449166317/019d0267-b6c8-7065-b1ba-180bbe13ab01.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "850 - 1050",
  "property_sqft_min": "850",
  "property_sqft_max": "1050",
  "property_price_range": "1416 - 1939",
  "property_price_min": "1416",
  "property_price_max": "1939",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/FranklinCommonsApts/",
  "property_instagram_url": "https://www.instagram.com/franklincommonsapartments/",
  "property_twitter_url": "https://www.twitter.com/franklincmnsapt",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJb6zcdhBNwYkRO2gxItlH-dc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Bensalem%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Franklin Commons Apartments",
  "property_home_romance_title": "Embrace Your Ideal Lifestyle at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Franklin Commons Apartments in Bensalem, PA, where modern living meets comfort. Choose from spacious one or two-bedroom floor plans, and enjoy amenities like a sparkling swimming pool, dog park, and vibrant resident activities. Embrace convenience with our bilingual team, online portal, and flexible rent options. Your ideal lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to Franklin Commons Apartments in Bensalem, PA, where comfort meets convenience. Choose from stylish one and two-bedroom layouts designed for modern living. Each home offers unique charm and functionality. Browse our available apartment homes today and uncover the perfect floor plan tailored to your lifestyle!",
  "property_home_gallery_blurb": "At Franklin Commons Apartments in Bensalem, PA, your ideal home awaits with one and two-bedroom floor plans designed for comfort. Enjoy modern amenities like a fitness center, swimming pool, and vibrant community events. Picture yourself lounging by the fire pit or taking your furry friend to the dog park!",
  "property_home_neighborhood_blurb": "At Franklin Commons Apartments in Bensalem, PA, experience a vibrant lifestyle surrounded by parks, schools, and entertainment options. With spacious one- and two-bedroom floor plans, you're just moments away from the serene Neshaminy State Park or the excitement of Parx Casino. Embrace the perfect blend of comfort and convenience!",
  "property_home_reviews_blurb": "At Franklin Commons Apartments in Bensalem, PA, you'll find a community where \"the staff is incredibly helpful and genuine.\" Residents applaud our welcoming atmosphere and spacious, cozy apartments, complete with ample amenities. From swift maintenance to an Olympic-sized pool, your perfect home awaits. Join us and see why everyone loves living here!",
  "property_neighborhood_blurb": "At Franklin Commons Apartments in Bensalem, you'll find more than just a home—you're nestled in a vibrant tapestry of life. Nearby parks, schools, and recreational facilities invite exploration, while the Neshaminy Mall and local theaters offer endless entertainment. Uncover the charm of this dynamic community today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Franklin Commons Apartments in Bensalem, PA, your lifestyle blends comfort and convenience. Choose from spacious one- or two-bedroom floor plans, all adorned with modern finishes. Enjoy a vibrant community featuring a fitness center, swimming pool, and a dog park—all designed to elevate your living experience. Join us today!",
  "property_applynow_blurb": "At Franklin Commons Apartments in Bensalem, PA, you'll find the perfect blend of comfort and convenience. Choose from spacious one and two-bedroom floor plans while enjoying amenities like a pet-friendly environment, a fitness center, and a sparkling swimming pool. Ready to make a move? Lease online today!",
  "property_contactus_blurb": "At Franklin Commons Apartments in Bensalem, PA, find your ideal home with thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Each space offers comfort and style, ensconced in a vibrant community. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Franklin Commons Apartments in Bensalem, PA, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Have questions? Dive into our FAQs page for insights on community features, amenities, and more. Your ideal living experience awaits—let’s find your perfect fit today!",
  "property_floorplans_blurb": "At Franklin Commons Apartments in Bensalem, PA, you’ll find thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Each space combines comfort and modern aesthetics, ensuring a welcoming haven. Browse our available apartment homes and uncover the perfect layout to suit your needs!",
  "property_gallery_blurb": "At Franklin Commons Apartments in Bensalem, PA, every moment feels like home. Choose from stylish one and two-bedroom floor plans, and indulge in exceptional amenities, from our fitness center and swimming pool to a pet-friendly environment. Picture yourself relaxing by the fire pit or having fun at our game room!",
  "property_interactivemap_blurb": "At Franklin Commons Apartments in Bensalem, PA, you’ll find an array of thoughtfully designed one and two-bedroom floor plans alongside a vibrant community. Enjoy amenities like a pet-friendly park, a spacious clubhouse, and a refreshing swimming pool. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to Franklin Commons Apartments in Bensalem, PA, where your furry friends can thrive alongside you. With our pet-friendly policy, you can bring up to two beloved companions, free of weight restrictions—just a simple one-time fee and monthly rent awaits. Live comfortably with your pets by your side!",
  "property_referafriend_blurb": "At Franklin Commons Apartments in Bensalem, PA, we believe that great friends make great neighbors! With inviting one- and two-bedroom floor plans, there’s a perfect space for everyone. Share your love for our community and refer a friend today—because life’s better when shared with those you love!",
  "property_residentaccess_blurb": "Welcome to Franklin Commons Apartments in Bensalem, PA, where modern living meets convenience. Choose from spacious one and two-bedroom floor plans tailored to fit your lifestyle. Access your resident portal for hassle-free rent payments, maintenance scheduling, and a host of resident services designed for your comfort and ease!",
  "property_reviews_blurb": "At Franklin Commons Apartments in Bensalem, PA, our residents rave about the welcoming atmosphere and attentive staff, with one noting, “The office staff is incredibly helpful and genuine.” Enjoy tidy, spacious living with quick maintenance responses and an inviting community—all just minutes from shopping and dining. Join us today!",
  "property_created_at": "1757005152090",
  "property_scheduletour_blurb": "At Franklin Commons Apartments in Bensalem, PA, we offer spacious one and two-bedroom floor plans designed for modern living. Schedule a tour today to experience our vibrant community and see what our residents love about calling Franklin Commons home. Join us and write your own story in Bensalem!",
  "property_thankyou_blurb": "Thank you for reaching out to Franklin Commons Apartments in Bensalem, PA! Our inviting community features thoughtfully designed one and two-bedroom floor plans, tailored to your lifestyle. A member of our team will be in touch soon to help you find your perfect home. Welcome to your new beginning!",
  "property_virtualtours_blurb": "Step into the charm of Franklin Commons Apartments in Bensalem, PA. With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. Experience the comfort and style from the comfort of your home—take a virtual tour of our vibrant community and explore your future today!",
  "property_copyright": "2025 All Rights Reserved. Franklin Commons Apartments",
  "property_seo_title_home": "Franklin Commons Apartments |  Apartments in Bensalem, PA",
  "property_seo_description_home": "Franklin Commons offers renovated 1- and 2-bedroom apartments in Bensalem, PA, with a pool, fitness center, dog park, and a private patio or balcony.",
  "property_seo_title_floorplans": "1 & 2 Bedroom Apartments in Bensalem, PA | Franklin Commons",
  "property_seo_description_floorplans": "Compare renovated 1 and 2-bedroom floor plans at Franklin Commons Apartments in Bensalem, PA, with private entrances and a balcony or patio.",
  "property_seo_title_amenities": "Pet-Friendly Apartments in Bensalem, PA | Franklin Commons",
  "property_seo_description_amenities": "Enjoy a swimming pool, fitness center, clubhouse, dog park, and package lockers at Franklin Commons, pet-friendly apartments in Bensalem, PA",
  "property_seo_title_gallery": "Franklin Commons Apartments Photos | Bensalem, PA",
  "property_seo_description_gallery": "Browse photos of Franklin Commons Apartments in Bensalem, PA, including renovated 1 & 2 bedroom interiors, the pool, clubhouse and dog park.",
  "property_seo_title_virtualtours": "Virtual Apartment Tours in Bensalem, PA | Franklin Commons",
  "property_seo_description_virtualtours": "Take a 360° virtual tour of 1- and 2-bedroom apartments at Franklin Commons in Bensalem, PA, and explore the layouts before you visit.",
  "property_seo_title_interactivemap": "Interactive Map | Franklin Commons Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Franklin Commons Apartments in Bensalem, PA! Use our interactive map to explore one and two-bedroom layouts and amenities galore!",
  "property_seo_title_neighborhood": "Apartments Near Neshaminy State Park | Franklin Commons",
  "property_seo_description_neighborhood": "Live near Neshaminy State Park, Neshaminy Mall and Parx Casino at Franklin Commons Apartments in Bensalem, PA, in the heart of Bucks County.",
  "property_seo_title_contact": "Contact Franklin Commons Apartments | Bensalem, PA",
  "property_seo_description_contact": "Contact Franklin Commons Apartments at 1400 Cardinal Dr, Bensalem, PA 19020 for availability, tours, and leasing details. Our bilingual team can help.",
  "property_seo_title_faqs": "FAQs | Apartments in Bensalem, PA",
  "property_seo_description_faqs": "Find all the answers you need about Franklin Commons Apartments in Bensalem, PA. From amenities to leasing info, our FAQs page has you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bensalem, PA",
  "property_seo_description_reviews": "Experience life at Franklin Commons Apartments in Bensalem, PA—where community meets comfort! Check out resident reviews and find your perfect home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bensalem, PA",
  "property_seo_description_applynow": "Unwind at Franklin Commons in Bensalem! Choose from stylish one or two-bedroom apartments with amazing amenities. Lease online today for your perfect new home!",
  "property_seo_title_residentaccess": "Resident Access | Franklin Commons Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Franklin Commons Apartments! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Franklin Commons Apartments",
  "property_seo_description_referafriend": "Bring friends to Franklin Commons in Bensalem! Great neighbors create a vibrant community. Refer a friend today and enjoy living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Franklin Commons Apartments",
  "property_seo_description_scheduletour": "Experience vibrant living at Franklin Commons Apartments in Bensalem, PA. Schedule your tour today and find your perfect home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Franklin Commons Apartments",
  "property_seo_description_privacy": "Protect your information while enjoying life at Franklin Commons Apartments in Bensalem, PA. Our privacy policy ensures your peace of mind. Read more now!",
  "property_seo_title_accessibility": "Website Accessibility | Franklin Commons Apartments",
  "property_seo_description_accessibility": "Franklin Commons Apartments in Bensalem prioritizes digital accessibility, fostering an inclusive community for everyone’s comfort and convenience.",
  "property_seo_title_sitemap": "Sitemap | Franklin Commons Apartments",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Franklin Commons Apartments in Bensalem, PA. Check out our sitemap for easy access to all community features!",
  "property_seo_title_thankyou": "Thank You | Franklin Commons Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Franklin Commons Apartments in Bensalem, PA! We’ll connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Bensalem, PA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793722830617",
  "amenities": [
    {
      "id": "custom_56cc9fc7-b236-4361-acd9-cd37149a7697",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da8317d5-922b-4bb4-bf0e-6c0c88a4d921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Bilingual Site Team",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eabaa254-49fb-4f67-a8cb-1ab2badafe2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61f0a60d-9f47-4618-b657-90ac45c5f653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32a302a0-b922-4890-a694-7fb4bd0579a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6e600cb-a21c-4b7e-bb95-f2e49e924613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eebd33b5-c6f8-4b80-abed-813a46c9b499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fde17c0b-06a7-45ba-adfa-3715286bcb7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9918ca3e-3ed4-414d-8817-10149dcf47a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a797ec86-a90b-4550-8501-668f7da80ae4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc6411d3-79f1-4100-aae3-4d1350f14916",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3420f2e-7dec-428f-a0e4-1f7edcb4f38d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e0eaba3-3d62-4d0f-86af-50e1c8cd422b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Abundant Closet Space",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_446ae6b9-6bcd-4a5b-b8b8-f7c307403567",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances w/ Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3c7a84d-0e3a-4752-91d5-de7618a9ea9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3bf47d4c-1a02-4106-bc63-ce0ec3f2a6e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33ca03fd-ef05-4bf0-8c4e-6a532d02ed43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Individual Climate Control",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a0476a3d-be92-4ed1-9853-5c660d05f545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d5a1f34-c406-4a7b-afb5-67ce325703c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Private Entrance",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c56b00c-37b7-4032-a008-57aa30b60c56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated 1 & 2 Bedroom Apartment Homes",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9fa3e8a-74f5-4a0a-863e-5e824efc65e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-Wall Carpet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_185d2c24-f5f8-4831-8b2a-9918b29d12a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5f28f82-5dc7-43ed-8d0a-d720349b13a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park at Franklin Commons",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f40eba63-1c21-476d-9464-aa537bb680e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a458160-2acb-4eaa-8301-de9f70aa0ef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Free Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a020bff6-f8fc-43a5-a28c-33395cb55100",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f896dac1-afbb-4915-b7ff-0d9f8dd1c30b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1156aaaf-66bb-4cd6-bb6b-5944ef509ac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ed23f34-8de4-43dd-9f83-40be365d4858",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a090e9ce-a0f8-4f6c-9133-009e378472ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_377e3a51-b8c5-43c0-838f-b013428ea8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b512769-2239-4f14-b9d8-a5819442be30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_46702e60-016e-42d3-b0a2-b2ba7c58505d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-eba5-72a9-8075-82fdc25525d3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-eba5-72a9-8075-82fdc25525d3",
        "storage_key": "property/6767906449166317/01a1602a-eba5-72a9-8075-82fdc25525d3.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and sleek countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86c5132e-873b-437a-a9ff-f21a51e25ac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-ee29-7162-bad3-8a782b8b2f81.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, console table with vases and picture frames, and a wall-mounted TV at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-ee29-7162-bad3-8a782b8b2f81",
        "storage_key": "property/6767906449166317/01a1602a-ee29-7162-bad3-8a782b8b2f81.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush gray sofa, a stylish console table, and a large wall-mounted TV for your entertainment needs.",
      "link": "",
      "alt_text": "Living room with a gray sofa, console table with vases and picture frames, and a wall-mounted TV at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2701df9-4b10-40f7-bf53-bdba2b7714c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-e580-7197-9949-52211e929e96.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and chairs, ceiling fan, and sliding glass doors at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-e580-7197-9949-52211e929e96",
        "storage_key": "property/6767906449166317/01a1602a-e580-7197-9949-52211e929e96.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, featuring a wooden table set for six, a ceiling fan, and convenient access to the outdoors through sliding glass doors.",
      "link": "",
      "alt_text": "Dining area with a wooden table and chairs, ceiling fan, and sliding glass doors at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7f12306-24d5-4448-bdc8-769e2f32f4d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-f01c-720d-aa51-3bd51a4e213f.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, TV, and a console table at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-f01c-720d-aa51-3bd51a4e213f",
        "storage_key": "property/6767906449166317/01a1602a-f01c-720d-aa51-3bd51a4e213f.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, modern entertainment center, and elegant console table, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, TV, and a console table at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1baf9e6-63f3-4a71-803a-8fa2480fe82a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-777b-755b-987e-c6945eb943dc.webp",
      "image_media": {
        "alt_text": "Queen-size bed with white linens and gray accents in a well-lit bedroom at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-777b-755b-987e-c6945eb943dc",
        "storage_key": "property/6767906449166317/01a1602a-777b-755b-987e-c6945eb943dc.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this inviting bedroom, perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Queen-size bed with white linens and gray accents in a well-lit bedroom at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4c4502e-3a04-4e1b-ad47-0550a6efc49c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-b6dc-77b8-8453-3eae1ba0bbc0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-b6dc-77b8-8453-3eae1ba0bbc0",
        "storage_key": "property/6767906449166317/01a1602a-b6dc-77b8-8453-3eae1ba0bbc0.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a pristine white bathtub, modern toilet, and sleek vanity, all designed for comfort and style.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_38787e26-8505-4b36-9e79-56a1bb902440",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-50fd-73d9-8e49-96d5e6f6ea1e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a breakfast bar at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-50fd-73d9-8e49-96d5e6f6ea1e",
        "storage_key": "property/6767906449166317/01a1602a-50fd-73d9-8e49-96d5e6f6ea1e.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Apartment",
      "description": "This apartment kitchen features dark wood cabinetry, stainless steel appliances, and a convenient built-in breakfast bar perfect for morning coffee or working from home.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a breakfast bar at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ae8d7b9-93ed-4395-90eb-5f38a0fcc15c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-7406-701f-8dc3-384603b5049e.webp",
      "image_media": {
        "alt_text": "Living room with a grey sofa and a patterned rug at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-7406-701f-8dc3-384603b5049e",
        "storage_key": "property/6767906449166317/01a1602a-7406-701f-8dc3-384603b5049e.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable grey sofa, a cozy patterned rug, and an adjacent dining area and kitchen.",
      "link": "",
      "alt_text": "Living room with a grey sofa and a patterned rug at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b006b0d8-6988-4854-8724-9fd0b4cb5af5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-9ec7-762e-9d73-c8050e8b2676.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment unit at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-9ec7-762e-9d73-c8050e8b2676",
        "storage_key": "property/6767906449166317/01a1602a-9ec7-762e-9d73-c8050e8b2676.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, adjacent to a modern kitchen featuring ample cabinet space and a full-size refrigerator.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment unit at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f727153e-7ece-43d7-8892-0b9442701463",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-7c4c-75f5-ba2f-d132a3dd5904.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray couch, armchair, floor lamp, and TV mounted on the wall at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-7c4c-75f5-ba2f-d132a3dd5904",
        "storage_key": "property/6767906449166317/01a1602a-7c4c-75f5-ba2f-d132a3dd5904.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring comfortable seating, a flat-screen TV, and ample natural light.",
      "link": "",
      "alt_text": "Modern living room with a gray couch, armchair, floor lamp, and TV mounted on the wall at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_710f2de5-db9b-4a15-96cb-639eb7951b73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-a7b6-7108-ad4e-5dc4906afd96.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, desk, and laptop at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-a7b6-7108-ad4e-5dc4906afd96",
        "storage_key": "property/6767906449166317/01a1602a-a7b6-7108-ad4e-5dc4906afd96.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a functional desk with a laptop, and large windows for natural light. Perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Bedroom with a bed, desk, and laptop at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_64ab1a8b-1ffd-4eae-810c-96b617dcd782",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-a51a-7508-86ad-24e9f5e98d14.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a closet at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-a51a-7508-86ad-24e9f5e98d14",
        "storage_key": "property/6767906449166317/01a1602a-a51a-7508-86ad-24e9f5e98d14.webp",
        "width": 3072,
        "height": 2022
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-sized bed, elegant nightstands with modern lamps, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom with a large bed, nightstands, and a closet at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ff5bc24-4479-47a0-b99f-c02c0b443131",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-8151-70d9-8f80-f1782ab8400c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and stainless steel appliances; white subway tile backsplash at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-8151-70d9-8f80-f1782ab8400c",
        "storage_key": "property/6767906449166317/019fd956-8151-70d9-8f80-f1782ab8400c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets and stainless steel appliances; white subway tile backsplash at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/88d629dc1e9352aee9236439baa662f4-1920w.webp"
    },
    {
      "id": "custom_ac833be7-083b-49e2-8519-71aacdf77e31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-8caf-7678-8542-11f374c9cfae.webp",
      "image_media": {
        "alt_text": "Bathroom featuring a tub/shower, toilet, and vanity at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-8caf-7678-8542-11f374c9cfae",
        "storage_key": "property/6767906449166317/019fd956-8caf-7678-8542-11f374c9cfae.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with tub/shower, white tile surround, and a dark-wood vanity.",
      "link": "",
      "alt_text": "Bathroom featuring a tub/shower, toilet, and vanity at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/5150fb324169d2b3a5876ba72e143bcc-1920w.jpg"
    },
    {
      "id": "custom_5cfa8bd2-be9d-4330-9376-302ba89db35c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-8d3b-71cd-87c8-b5ff6841b6b2.webp",
      "image_media": {
        "alt_text": "Balcony with a black railing and wooden deck overlooks a grassy courtyard and a row of brick apartment buildings at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-8d3b-71cd-87c8-b5ff6841b6b2",
        "storage_key": "property/6767906449166317/019fd956-8d3b-71cd-87c8-b5ff6841b6b2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy the outdoors from your private balcony, overlooking lush green lawns and mature trees. A perfect spot to relax and take in the scenery.",
      "link": "",
      "alt_text": "Balcony with a black railing and wooden deck overlooks a grassy courtyard and a row of brick apartment buildings at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/c9348b86dee1f533b8611b9840b1491e-1920w.jpg"
    },
    {
      "id": "custom_18cc29da-c674-4d8e-abcf-83d789268c68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-90f1-7339-b5ac-75071f7e9adc.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with lounge chairs and umbrellas at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-90f1-7339-b5ac-75071f7e9adc",
        "storage_key": "property/6767906449166317/019fd956-90f1-7339-b5ac-75071f7e9adc.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Outdoor pool area for residents with lounge chairs, umbrellas, and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with lounge chairs and umbrellas at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/b12e0528cb7ce84d381d05f8d670b312-1920w.jpg"
    },
    {
      "id": "custom_449db389-22d6-4e5b-9a64-e66a3fef6891",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-91c0-739f-a8f8-318ed2d853ad.webp",
      "image_media": {
        "alt_text": "Outdoor community pool area with lounge chairs and umbrellas on a sunny day at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-91c0-739f-a8f8-318ed2d853ad",
        "storage_key": "property/6767906449166317/019fd956-91c0-739f-a8f8-318ed2d853ad.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Outdoor community pool area with lounge chairs and umbrellas on a sunny day at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/180a64fa7cfa67fe2ebdbecac9267f0a-1920w.jpg"
    },
    {
      "id": "custom_9b2dc482-a565-407f-b983-0c9323f03d0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-98c5-70cb-98dc-f40c1bbb1635.webp",
      "image_media": {
        "alt_text": "Bright, modern apartment gym with cardio machines and mirrors at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-98c5-70cb-98dc-f40c1bbb1635",
        "storage_key": "property/6767906449166317/019fd956-98c5-70cb-98dc-f40c1bbb1635.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Bright, modern apartment gym with cardio machines and mirrors at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/bbbd90f501a2e429fa2c6aba2b8cb5d4-1920w.webp"
    },
    {
      "id": "custom_f45e5e28-01c1-479b-94ce-5e2f47e2ca82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-9abc-70eb-95fd-107623437918.webp",
      "image_media": {
        "alt_text": "Indoor community gym with treadmills, ellipticals, and stationary bikes at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-9abc-70eb-95fd-107623437918",
        "storage_key": "property/6767906449166317/019fd956-9abc-70eb-95fd-107623437918.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "On-site resident gym with cardio equipment such as treadmills, ellipticals, and stationary bikes.",
      "link": "",
      "alt_text": "Indoor community gym with treadmills, ellipticals, and stationary bikes at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/c2f18f4952a2a9f6a84e946c7601e42c-1920w.webp"
    },
    {
      "id": "custom_7cbf4cef-18ac-432d-ad5f-58684f740ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-b39c-712e-bcfc-f14ed69e3072.webp",
      "image_media": {
        "alt_text": "Bright community gym with cardio machines, free weights, and mirrors at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-b39c-712e-bcfc-f14ed69e3072",
        "storage_key": "property/6767906449166317/019fd956-b39c-712e-bcfc-f14ed69e3072.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Well-equipped on-site gym for residents with cardio machines, free weights, and a mirrored wall.",
      "link": "",
      "alt_text": "Bright community gym with cardio machines, free weights, and mirrors at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/8d0089c0a19a955c61f561b04c6933a9-1920w.jpg"
    },
    {
      "id": "custom_82108fea-c72e-440b-b317-075b62dcbc05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-b103-71cb-b1b9-634af7f33807.webp",
      "image_media": {
        "alt_text": "Fenced community playground with grass and play structures, with apartment buildings in the background at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-b103-71cb-b1b9-634af7f33807",
        "storage_key": "property/6767906449166317/019fd956-b103-71cb-b1b9-634af7f33807.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Fenced community playground with grass and play structures, with apartment buildings in the background at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/cd031dffb7feea4ce88b29e9d29150d8-7f57dc5e-1920w.jpg"
    },
    {
      "id": "custom_a09a138e-8171-400a-8185-f1fa79115212",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-97a1-765b-8ed5-f6a3aa9e0b1c.webp",
      "image_media": {
        "alt_text": "Outdoor blue tennis court with nets, fenced, and a playground in the background at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-97a1-765b-8ed5-f6a3aa9e0b1c",
        "storage_key": "property/6767906449166317/019fd956-97a1-765b-8ed5-f6a3aa9e0b1c.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Outdoor blue tennis court with nets, fenced, and a playground in the background at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/a1c0a32ad535ed0845b286d27d02ead6-1920w.webp"
    },
    {
      "id": "custom_6797562a-0c21-4ec7-be13-444cb126a71e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-b116-72cf-a76a-ac00067dc7be.webp",
      "image_media": {
        "alt_text": "Orange playground equipment with swings on wood-chip ground, fence and apartment buildings in the background at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-b116-72cf-a76a-ac00067dc7be",
        "storage_key": "property/6767906449166317/019fd956-b116-72cf-a76a-ac00067dc7be.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community playground with bright orange structures and swings, fenced area near apartment buildings.",
      "link": "",
      "alt_text": "Orange playground equipment with swings on wood-chip ground, fence and apartment buildings in the background at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/17efd699ad396a4d5c0788d116ba1081-1920w.jpg"
    },
    {
      "id": "custom_7d55351b-9d7c-40e4-a3f8-01b788075d12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-bd31-728c-8bab-8ccfd166045b.webp",
      "image_media": {
        "alt_text": "Outdoor sand volleyball court with a net, surrounded by grass and trees at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-bd31-728c-8bab-8ccfd166045b",
        "storage_key": "property/6767906449166317/019fd956-bd31-728c-8bab-8ccfd166045b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor volleyball court at the apartment community, with surrounding greenery and seating nearby.",
      "link": "",
      "alt_text": "Outdoor sand volleyball court with a net, surrounded by grass and trees at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/257596b7a5826e6e3542255e86507145-1920w.jpg"
    },
    {
      "id": "custom_0cc62c0a-f82f-4b8b-bf28-ea4f5eae1a02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-9c5a-74de-a547-2c171fd3817f.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with orange chairs and a fire pit in front of apartment buildings at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-9c5a-74de-a547-2c171fd3817f",
        "storage_key": "property/6767906449166317/01a1602a-9c5a-74de-a547-2c171fd3817f.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Gather around the fire pit on the patio with comfortable seating. Enjoy the outdoor amenities.",
      "link": "",
      "alt_text": "Outdoor patio area with orange chairs and a fire pit in front of apartment buildings at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36fd9cdf-be71-46ec-b574-b4e5a3db5869",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-8fc3-755c-bca8-b3f8655c9afe.webp",
      "image_media": {
        "alt_text": "Game room with pool table, shuffleboard table, and seating area at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-8fc3-755c-bca8-b3f8655c9afe",
        "storage_key": "property/6767906449166317/01a1602a-8fc3-755c-bca8-b3f8655c9afe.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Enjoy downtime in our community game room featuring a pool table, shuffleboard, and comfortable seating. Perfect for friendly competition or relaxation.",
      "link": "",
      "alt_text": "Game room with pool table, shuffleboard table, and seating area at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_505893e0-4698-4dac-8a9b-75f8da8ed43b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-9713-771c-8135-efdd4eee02f1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sectional sofa, chairs, and coffee table in a multifamily property at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-9713-771c-8135-efdd4eee02f1",
        "storage_key": "property/6767906449166317/01a1602a-9713-771c-8135-efdd4eee02f1.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring comfortable seating and a contemporary design.",
      "link": "",
      "alt_text": "Modern lounge area with sectional sofa, chairs, and coffee table in a multifamily property at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a292a24-4175-4123-bc4c-250326cd41a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-94aa-76fd-87df-708132bc46d5.webp",
      "image_media": {
        "alt_text": "Community room with a high table and chairs, a TV displaying a fall scene, and modern art on the wall at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-94aa-76fd-87df-708132bc46d5",
        "storage_key": "property/6767906449166317/01a1602a-94aa-76fd-87df-708132bc46d5.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Relax and socialize in our modern community room, featuring a large communal table, comfortable seating, and entertainment options.",
      "link": "",
      "alt_text": "Community room with a high table and chairs, a TV displaying a fall scene, and modern art on the wall at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cf024d1b-d6fb-4193-ba07-95b2b7479373",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-a622-729a-a9bd-cb9901d1b3d3.webp",
      "image_media": {
        "alt_text": "Interior community lounge with a sloped wooden ceiling, tables, and seating at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-a622-729a-a9bd-cb9901d1b3d3",
        "storage_key": "property/6767906449166317/019fd956-a622-729a-a9bd-cb9901d1b3d3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright, modern shared lounge at a multifamily community with communal tables, couches, and contemporary decor.",
      "link": "",
      "alt_text": "Interior community lounge with a sloped wooden ceiling, tables, and seating at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/7d8c899c6ca34789249d0c88b93db671-1920w.webp"
    },
    {
      "id": "custom_e2840ead-a4c5-4e79-922f-67b63b74e81f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-601d-73fb-ac24-198e4342cf7f.webp",
      "image_media": {
        "alt_text": "Outdoor patio with fire pit, orange chairs, and grills under string lights at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-601d-73fb-ac24-198e4342cf7f",
        "storage_key": "property/6767906449166317/01a1602a-601d-73fb-ac24-198e4342cf7f.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Enjoy community gatherings and cookouts on our spacious outdoor patio, featuring a fire pit, comfortable seating, and multiple grills.",
      "link": "",
      "alt_text": "Outdoor patio with fire pit, orange chairs, and grills under string lights at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8fead37-331e-4cc6-9123-06e3077bbf67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-645b-723b-b5f0-72f422425f60.webp",
      "image_media": {
        "alt_text": "Outdoor patio with fire pit and orange chairs, leading to building entrance with string lights at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-645b-723b-b5f0-72f422425f60",
        "storage_key": "property/6767906449166317/01a1602a-645b-723b-b5f0-72f422425f60.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Gather around the fire pit on the outdoor patio, perfect for relaxing evenings under the string lights. Comfortable seating and a welcoming ambiance for residents.",
      "link": "",
      "alt_text": "Outdoor patio with fire pit and orange chairs, leading to building entrance with string lights at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_295ea82e-37df-456c-a4e0-e7001c7869a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-8ef1-764c-866d-ce045c18f2c0.webp",
      "image_media": {
        "alt_text": "Exterior of a community clubhouse with a large green lawn and cornhole boards at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-8ef1-764c-866d-ce045c18f2c0",
        "storage_key": "property/6767906449166317/01a1602a-8ef1-764c-866d-ce045c18f2c0.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Enjoy outdoor activities on the lawn with cornhole boards, adjacent to the community clubhouse.",
      "link": "",
      "alt_text": "Exterior of a community clubhouse with a large green lawn and cornhole boards at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b8ea5c8-43c5-4271-8157-ecb3002bd711",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-a012-75fc-8b47-49191acbf4db.webp",
      "image_media": {
        "alt_text": "Package lockers outside a multifamily property at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-a012-75fc-8b47-49191acbf4db",
        "storage_key": "property/6767906449166317/01a1602a-a012-75fc-8b47-49191acbf4db.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Secure package lockers available for residents.",
      "link": "",
      "alt_text": "Package lockers outside a multifamily property at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68df285b-70d2-4690-a1a2-c3dafc65f6db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-8d47-778c-bdaa-c94ab645e4b8.webp",
      "image_media": {
        "alt_text": "Exterior of a tan multifamily building with white columns and a tree logo above the entrance at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-8d47-778c-bdaa-c94ab645e4b8",
        "storage_key": "property/6767906449166317/01a1602a-8d47-778c-bdaa-c94ab645e4b8.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Welcome to our beautiful community! This exterior shot highlights the main building with its inviting entrance and well-maintained landscaping. The \"Now Leasing\" and \"Pet Friendly\" banners indicate availability and pet accommodations.",
      "link": "",
      "alt_text": "Exterior of a tan multifamily building with white columns and a tree logo above the entrance at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bcbac0f-77f4-4968-b0eb-841051269d34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fd956-bf25-731b-b7db-de904e5f7559.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with a green lawn, trees, and clear blue sky at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "019fd956-bf25-731b-b7db-de904e5f7559",
        "storage_key": "property/6767906449166317/019fd956-bf25-731b-b7db-de904e5f7559.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a multi-family apartment building with a well-kept lawn and shrubs.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with a green lawn, trees, and clear blue sky at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/c4d7b1aa/dms3rep/multi/opt/5767906449162442/6767906449166317/6ae787249a7a71e0f46e8c0a3757e4a6-1920w.webp"
    },
    {
      "id": "custom_0de7f5df-f1b1-4caa-bce6-ab4bcd7d2d9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a1602a-c81b-72d9-a8a7-796f810feb1f.webp",
      "image_media": {
        "alt_text": "Franklin Commons monument sign with rental information and clubhouse details at Franklin Commons Apartments in Bensalem, PA.",
        "public_id": "01a1602a-c81b-72d9-a8a7-796f810feb1f",
        "storage_key": "property/6767906449166317/01a1602a-c81b-72d9-a8a7-796f810feb1f.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Welcome to Franklin Commons! Find rental information and clubhouse details at our prominent monument sign, surrounded by lush landscaping and vibrant flowers.",
      "link": "",
      "alt_text": "Franklin Commons monument sign with rental information and clubhouse details at Franklin Commons Apartments in Bensalem, PA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_aef71e7a-9cc8-45f7-b3f9-136084b4646a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2605 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-8d2e-714e-b28e-12172358462d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-8d2e-714e-b28e-12172358462d",
        "storage_key": "property/6767906449166317/019d0265-8d2e-714e-b28e-12172358462d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/pa/bensalem/2605-street-road?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=203986&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=4485076403160447829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "40.1090937",
      "poi_longitude": "-74.9512558",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-639-2046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2992-70fc-9669-7fa7d8ac6410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2992-70fc-9669-7fa7d8ac6410",
        "storage_key": "property/6767906449166317/019d0266-2992-70fc-9669-7fa7d8ac6410.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB3OlEjlNwYkRVXvdyDkxPj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_3d3c1858-3aa3-4aed-89e2-ed485f218e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "2721 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-8f12-711a-817f-d54b5ce43998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-8f12-711a-817f-d54b5ce43998",
        "storage_key": "property/6767906449166317/019d0265-8f12-711a-817f-d54b5ce43998.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator",
      "poi_directions_map_url": "https://maps.google.com/?cid=4079083189407068048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "40.111176",
      "poi_longitude": "-74.95130999999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-604-9924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2992-70fc-9669-7fa7d8ac6410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2992-70fc-9669-7fa7d8ac6410",
        "storage_key": "property/6767906449166317/019d0266-2992-70fc-9669-7fa7d8ac6410.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJydxAGvNNwYkRkC_ggYzQmzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5c160755-4201-41dd-8e69-42e5468a8501",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Sunrise Diner",
      "poi_type": "Restaurants",
      "poi_address": "416 Bristol Pike, Croydon, PA 19021, USA",
      "poi_short_description": "American home cooking for breakfast, lunch & dinner in a relaxed setting with comfortable booths.",
      "poi_long_description": "American home cooking for breakfast, lunch & dinner in a relaxed setting with comfortable booths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-8dd2-70fd-a927-d2b634b01e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-8dd2-70fd-a927-d2b634b01e12",
        "storage_key": "property/6767906449166317/019d0265-8dd2-70fd-a927-d2b634b01e12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sunrisediners.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13969737136218172550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunrise-diner",
      "poi_latitude": "40.0934044",
      "poi_longitude": "-74.90981459999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-788-9587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJic7wLK5NwYkRhuzdGel53sE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_9932be0e-1369-456d-88e2-7ea499744363",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Old Croydon Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1318 State Rd., Croydon, PA 19021, USA",
      "poi_short_description": "Casual eatery (breakfast-centric), making pancakes, omelets, hash browns, and waffles, as well as lunch dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-8e54-7261-bd7a-569fddab0c7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-8e54-7261-bd7a-569fddab0c7f",
        "storage_key": "property/6767906449166317/019d0265-8e54-7261-bd7a-569fddab0c7f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Old-croydon-cafe-141658369210180/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9276111316000296288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-croydon-cafe",
      "poi_latitude": "40.0885505",
      "poi_longitude": "-74.8985009",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-826-8062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SHsvrVNwYkRYM0tTxheu4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_41bc7420-3dd8-4dfc-82a8-2317db49f0ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Sakura Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1973 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Casual restaurant serving sushi, rolls, hibachi dishes, noodles & other Japanese fare.",
      "poi_long_description": "Casual restaurant serving sushi, rolls, hibachi dishes, noodles & other Japanese fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-94a0-712b-a73d-7efc942720c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-94a0-712b-a73d-7efc942720c7",
        "storage_key": "property/6767906449166317/019d0265-94a0-712b-a73d-7efc942720c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sakurasushipa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3812800947418797736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sakura-japanese-restaurant",
      "poi_latitude": "40.0973698",
      "poi_longitude": "-74.94542299999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-639-9988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXNFRyJNwYkRqJYrtkLK6TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_73eac177-618e-4c04-b4ff-ef76fc94f523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Chickie's & Pete's",
      "poi_type": "Restaurants",
      "poi_address": "2999 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Local sports-bar chain featuring a crab-heavy menu & signature Crabfries, plus lots of TVs.",
      "poi_long_description": "Local sports-bar chain featuring a crab-heavy menu & signature Crabfries, plus lots of TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-94b9-70c6-be23-8158f6b1306d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-94b9-70c6-be23-8158f6b1306d",
        "storage_key": "property/6767906449166317/019d0265-94b9-70c6-be23-8158f6b1306d.webp",
        "width": 587,
        "height": 391
      },
      "poi_business_url": "https://chickiesandpetes.com/location/parx-casino/?utm_source=gmb&utm_medium=organic&utm_campaign=parx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10988099263512679467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chickies--petes",
      "poi_latitude": "40.11868279999999",
      "poi_longitude": "-74.9533462",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 267-525-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2997-7613-9b4f-ace7c1a565a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2997-7613-9b4f-ace7c1a565a0",
        "storage_key": "property/6767906449166317/019d0266-2997-7613-9b4f-ace7c1a565a0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdyvZXkhNwYkRK5RnDhCSfZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_af018c6d-b08d-4ba3-8e5c-6da8a36f6e72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "La Choza Restaurant Latin Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "710 State Rd., Croydon, PA 19021, USA",
      "poi_short_description": "Mexican eatery serving burritos and fajitas in a lively atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-95f2-766f-b1c2-9129ebe9c248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-95f2-766f-b1c2-9129ebe9c248",
        "storage_key": "property/6767906449166317/019d0265-95f2-766f-b1c2-9129ebe9c248.webp",
        "width": 1168,
        "height": 750
      },
      "poi_business_url": "https://restaurantlachoza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16724472989532928099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-choza-restaurant-latin-cuisine",
      "poi_latitude": "40.0868263",
      "poi_longitude": "-74.9042096",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-458-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9nWlU1NwYkRY7i57JJDGeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2edc98c8-00ce-45b1-a327-60f7eef3f64e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Curran's Bensalem Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1909 Bristol Pike, Bensalem, PA 19020, USA",
      "poi_short_description": "The cozy pub atmosphere draws crowds for beer, wings, sports on TV & live music.",
      "poi_long_description": "The cozy pub atmosphere draws crowds for beer, wings, sports on TV & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-98e5-76a1-a64b-445b37f8d7a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-98e5-76a1-a64b-445b37f8d7a7",
        "storage_key": "property/6767906449166317/019d0265-98e5-76a1-a64b-445b37f8d7a7.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://curransbensalem.com/menu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713896764278066511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "currans-bensalem-restaurant",
      "poi_latitude": "40.075938",
      "poi_longitude": "-74.9543407",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-245-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-xFQMZMwYkRT004XPD67Xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7eea76ba-84cb-4a22-8535-dc1e84cbb9ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1545 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-9bde-7468-933a-8532c8e3dc52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9bde-7468-933a-8532c8e3dc52",
        "storage_key": "property/6767906449166317/019d0265-9bde-7468-933a-8532c8e3dc52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/pennsylvania/bensalem?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4940619951239497898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "40.0917803",
      "poi_longitude": "-74.9400386",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-639-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2307Lh5NwYkRqojWS6ubkEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a61f2de8-bf50-41d8-9df5-91374c5dbb4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "UNO Pizzeria & Grill",
      "poi_type": "Restaurants",
      "poi_address": "801 Neshaminy Mall, Bensalem, PA 19020, USA",
      "poi_short_description": "Family-friendly chain serving Chicago-style pizza along with pasta, steaks & burgers.",
      "poi_long_description": "Family-friendly chain serving Chicago-style pizza along with pasta, steaks & burgers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-a267-705e-99ca-3900e1bc6922.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a267-705e-99ca-3900e1bc6922",
        "storage_key": "property/6767906449166317/019d0265-a267-705e-99ca-3900e1bc6922.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://order.myguestaccount.com/menu/3509",
      "poi_directions_map_url": "https://maps.google.com/?cid=2397520300999167254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uno-pizzeria--grill",
      "poi_latitude": "40.13844",
      "poi_longitude": "-74.95799099999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-322-6003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZNKkKhSwYkRFs3X2gK0RSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_9c5c2d8a-6c76-4d76-9faf-f9e0c4c0fc6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Dom's Seafood",
      "poi_type": "Restaurants",
      "poi_address": "3975 Bristol Pike, Bensalem, PA 19020, USA",
      "poi_short_description": "Snug, unadorned venue selling fresh fish & shellfish as well as hot dishes for dine-in or takeout.",
      "poi_long_description": "Snug, unadorned venue selling fresh fish & shellfish as well as hot dishes for dine-in or takeout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-a54e-76ca-815f-16dd5d13365b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a54e-76ca-815f-16dd5d13365b",
        "storage_key": "property/6767906449166317/019d0265-a54e-76ca-815f-16dd5d13365b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/DomsSeafoodBensalem/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17081791407197591770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doms-seafood",
      "poi_latitude": "40.0929246",
      "poi_longitude": "-74.9168883",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-639-1965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5ZFRqlNwYkR2hhVGci2Du0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_2aca8b74-d901-45bd-ab0f-5236ccab9cbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Taste Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2365 Bristol Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Casual restaurant serving Chinese dishes such as lo mein, wonton soup, and curry, plus vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-a583-7747-9e63-f545f2296d93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a583-7747-9e63-f545f2296d93",
        "storage_key": "property/6767906449166317/019d0265-a583-7747-9e63-f545f2296d93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tastecafebensalem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9850170911537581129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste-cafe",
      "poi_latitude": "40.1323731",
      "poi_longitude": "-74.92358949999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-752-0888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR7A_IBSwYkRSUwVb0HWsog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_8b134689-1c91-4f4d-81e4-04b644baf57e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Champ's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5660, 1336 Bristol Pike, Bensalem, PA 19020, USA",
      "poi_short_description": "No-frills pizzeria dishing traditional & innovative pies plus handmade rolls for steaks & hoagies.",
      "poi_long_description": "No-frills pizzeria dishing traditional & innovative pies plus handmade rolls for steaks & hoagies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-aa84-76d9-8ef3-057f6c0c99d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-aa84-76d9-8ef3-057f6c0c99d2",
        "storage_key": "property/6767906449166317/019d0265-aa84-76d9-8ef3-057f6c0c99d2.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.champspizzabensalem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2821437885256721066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "champs-pizza",
      "poi_latitude": "40.0745867",
      "poi_longitude": "-74.9676748",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-633-0907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJde7TDrVMwYkRqmKO2s7CJyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_051d6f72-1c7a-40c0-8727-5ec970bfe678",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Fisher's Catering Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1858 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Warm eatery serving gnocchi, lobster ravioli and other Italian dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-aa65-71c9-95c9-e0ced40b3811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-aa65-71c9-95c9-e0ced40b3811",
        "storage_key": "property/6767906449166317/019d0265-aa65-71c9-95c9-e0ced40b3811.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12631446580061939537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fishers-catering-restaurant",
      "poi_latitude": "40.0953591",
      "poi_longitude": "-74.94491359999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cFo-WtOwYkRUSfqg73pS68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_29c7960f-1ecc-40fa-86ad-1e6af55b2fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "1336 Bristol Pike Suite 100, Bensalem, PA 19020, USA",
      "poi_short_description": "Neighborhood chain grocery outpost with a deli, bakery, and florist, plus prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-adb4-733d-9607-84310c736ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-adb4-733d-9607-84310c736ac1",
        "storage_key": "property/6767906449166317/019d0265-adb4-733d-9607-84310c736ac1.webp",
        "width": 1088,
        "height": 612
      },
      "poi_business_url": "https://local.acmemarkets.com/pa/bensalem/1336-bristol-pike-suite-100.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14517319906491834388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "40.0728537",
      "poi_longitude": "-74.96668149999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-638-8190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2994-7369-b528-7890ad34e520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2994-7369-b528-7890ad34e520",
        "storage_key": "property/6767906449166317/019d0266-2994-7369-b528-7890ad34e520.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJde7TDrVMwYkRFCAn9Ynhd8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f03baf9e-e182-4da6-9d33-ef70f2920853",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "ShopRite of Bensalem",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 Bristol Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-af2f-7124-a6ba-7c5f1ae5a50e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-af2f-7124-a6ba-7c5f1ae5a50e",
        "storage_key": "property/6767906449166317/019d0265-af2f-7124-a6ba-7c5f1ae5a50e.webp",
        "width": 1280,
        "height": 747
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=428",
      "poi_directions_map_url": "https://maps.google.com/?cid=1716614877112881131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-bensalem",
      "poi_latitude": "40.1297621",
      "poi_longitude": "-74.9239827",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-757-5491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2994-7369-b528-7890ad34e520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2994-7369-b528-7890ad34e520",
        "storage_key": "property/6767906449166317/019d0266-2994-7369-b528-7890ad34e520.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6WvRIBSwYkR6892viKk0hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_95e5e879-3c58-41bb-9a29-7a03e63e8998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1445 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-b36a-70aa-8dfd-be117e8c1eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b36a-70aa-8dfd-be117e8c1eaf",
        "storage_key": "property/6767906449166317/019d0265-b36a-70aa-8dfd-be117e8c1eaf.webp",
        "width": 1280,
        "height": 927
      },
      "poi_business_url": "https://stores.aldi.us/pa/bensalem/1445-street-road?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=7617105115272722442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.0904069",
      "poi_longitude": "-74.9389672",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2994-7369-b528-7890ad34e520.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2994-7369-b528-7890ad34e520",
        "storage_key": "property/6767906449166317/019d0266-2994-7369-b528-7890ad34e520.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ziIHR5NwYkRCjikxL5ktWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_88f378b6-e16b-404f-8f71-8211591a7daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "2250 Bristol Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-b361-715e-a860-19e08b222f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b361-715e-a860-19e08b222f60",
        "storage_key": "property/6767906449166317/019d0265-b361-715e-a860-19e08b222f60.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bensalem-pa-pharmacies/2250-bristol-rd-corner-of-bristol-road-and-hulmeville-road-bensalem-pa-19020/storeid=1281?WT.mc_id=LS_GOOGLE_FS_1281",
      "poi_directions_map_url": "https://maps.google.com/?cid=10853545154094308446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.1298127",
      "poi_longitude": "-74.9234804",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-757-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdPysoFSwYkRXhx0J9CJn5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6ea52c07-9bc2-436b-af9c-0a27a7c38033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "1549 Bristol Pike, Bensalem, PA 19020, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-b700-75e8-8797-68c0a8a64a1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b700-75e8-8797-68c0a8a64a1e",
        "storage_key": "property/6767906449166317/019d0265-b700-75e8-8797-68c0a8a64a1e.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/0045?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=4062346108980856495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.074207",
      "poi_longitude": "-74.960194",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-245-0879",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2a2b-763f-a473-75fc1e0faf11",
        "storage_key": "property/6767906449166317/019d0266-2a2b-763f-a473-75fc1e0faf11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8XP0wMlMwYkRr4Z-TENaYDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d8b3cbc1-c87f-4c70-9638-23384e226bf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1644 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-b583-71c9-8f61-3410d19cd19b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b583-71c9-8f61-3410d19cd19b",
        "storage_key": "property/6767906449166317/019d0265-b583-71c9-8f61-3410d19cd19b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/bensalem-township/1644-street-rd-11346?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15993158508444867567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.0926343",
      "poi_longitude": "-74.9427554",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-638-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fcb-73e8-a5c5-b2109a2b44e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fcb-73e8-a5c5-b2109a2b44e1",
        "storage_key": "property/6767906449166317/019d0266-2fcb-73e8-a5c5-b2109a2b44e1.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJzbhUoR9NwYkR71tflO0c890",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7ff9ddf7-2a61-4a6e-83dd-65fa96182e2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Rockhill Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-bab4-729c-9335-91650a9299c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bab4-729c-9335-91650a9299c3",
        "storage_key": "property/6767906449166317/019d0265-bab4-729c-9335-91650a9299c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/neshaminy/1183",
      "poi_directions_map_url": "https://maps.google.com/?cid=5921148992464270142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.135473",
      "poi_longitude": "-74.9623403",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-364-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc2-7440-9a62-0edb47d23585",
        "storage_key": "property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa5JRItxTwYkRPrP-FaMlLFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2a126db9-215c-4375-bdca-ea03cfab58fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "4201 Neshaminy Blvd, Bensalem, PA 19020, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-bc9e-772c-a9a7-58a021e3a23c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bc9e-772c-a9a7-58a021e3a23c",
        "storage_key": "property/6767906449166317/019d0265-bc9e-772c-a9a7-58a021e3a23c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/pa/bensalem/4201-neshaminy-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15770003919096529552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.1359911",
      "poi_longitude": "-74.950823",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 267-332-4115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc2-7440-9a62-0edb47d23585",
        "storage_key": "property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK6a7waZSwYkRkEJE6AJP2to",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_126c0d5b-7322-4cf4-bc55-7e0d12369fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "3461 Horizon Blvd, Trevose, PA 19053, USA",
      "poi_short_description": "Sprawling retail chain selling groceries, clothing and homewares, plus some electronics and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-be53-77e2-92aa-20cc3c0bc8e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-be53-77e2-92aa-20cc3c0bc8e7",
        "storage_key": "property/6767906449166317/019d0265-be53-77e2-92aa-20cc3c0bc8e7.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5131-bensalem-pa?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16550623575696266599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "40.1364628",
      "poi_longitude": "-74.9674539",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-942-4005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc2-7440-9a62-0edb47d23585",
        "storage_key": "property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiXIWo6tSwYkRZ9WUAHSgr-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_37ca370e-0828-437e-88d3-2a9711267899",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Neshaminy Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "707 Neshaminy Mall, Bensalem, PA 19020, USA",
      "poi_short_description": "Standard shopping center with apparel, home & shoe stores, plus dining options & a movie theater.",
      "poi_long_description": "Standard shopping center with apparel, home & shoe stores, plus dining options & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-bf40-722d-97a8-2dc449074c00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bf40-722d-97a8-2dc449074c00",
        "storage_key": "property/6767906449166317/019d0265-bf40-722d-97a8-2dc449074c00.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.neshaminymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17472505707194204876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy-mall",
      "poi_latitude": "40.1387936",
      "poi_longitude": "-74.9553502",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-357-6101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc2-7440-9a62-0edb47d23585",
        "storage_key": "property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_____xNNwYkRzMJLDV7PevI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_05902832-33f1-4ab2-9c68-94908686501b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Robert K Shafer Middle School",
      "poi_type": "Education",
      "poi_address": "3333 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-c262-74ab-96e5-ca124d19f567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c262-74ab-96e5-ca124d19f567",
        "storage_key": "property/6767906449166317/019d0265-c262-74ab-96e5-ca124d19f567.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bensalemsd-shafer.edlioschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4398159788892438458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-k-shafer-middle-school",
      "poi_latitude": "40.10071870000001",
      "poi_longitude": "-74.938434",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-750-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCUyMF4lSwYkRuj9XigZnCT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fd627a45-2970-422d-861d-3f4b157dfd40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Cecelia Snyder Middle School",
      "poi_type": "Education",
      "poi_address": "3330 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-c384-771c-b7da-3e871852784b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c384-771c-b7da-3e871852784b",
        "storage_key": "property/6767906449166317/019d0265-c384-771c-b7da-3e871852784b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bensalemsd-snyder.edlioschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7368059759230063413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecelia-snyder-middle-school",
      "poi_latitude": "40.102771",
      "poi_longitude": "-74.9420674",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-750-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgTr2hhdNwYkRNRPCOFCbQGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f7a5cd47-cd6d-47ea-8ad5-0c198b6ef9f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Benjamin Rush Elementary School",
      "poi_type": "Education",
      "poi_address": "3400 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-c5ee-722c-aac4-4362ec329b77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c5ee-722c-aac4-4362ec329b77",
        "storage_key": "property/6767906449166317/019d0265-c5ee-722c-aac4-4362ec329b77.webp",
        "width": 1080,
        "height": 508
      },
      "poi_business_url": "https://bensalemsd-rush.edlioschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1382996477602548003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benjamin-rush-elementary-school",
      "poi_latitude": "40.1040481",
      "poi_longitude": "-74.941051",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-750-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtZnInRdNwYkRI8kdDfhjMRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2732e3a7-2c86-464a-b7bf-b402ed4a3043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bensalem High School",
      "poi_type": "Education",
      "poi_address": "4319 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-c6f6-76b3-a2a5-6ce8ac804ba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c6f6-76b3-a2a5-6ce8ac804ba4",
        "storage_key": "property/6767906449166317/019d0265-c6f6-76b3-a2a5-6ce8ac804ba4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://bensalemsd-bhs.edlioschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14063313090564335692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensalem-high-school",
      "poi_latitude": "40.1127049",
      "poi_longitude": "-74.9315159",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-750-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG3Wgom1NwYkRTCgwyL7sKsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_710f4a87-3bfc-49b6-9258-c2d9a2412e37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Russell C. Struble Elementary School",
      "poi_type": "Education",
      "poi_address": "4300 Bensalem Blvd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-c9b6-7346-89a3-fb2244f5fc79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c9b6-7346-89a3-fb2244f5fc79",
        "storage_key": "property/6767906449166317/019d0265-c9b6-7346-89a3-fb2244f5fc79.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bensalemsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4556243287207372863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russell-c-struble-elementary-school",
      "poi_latitude": "40.099145",
      "poi_longitude": "-74.9211151",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-750-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9al2HwhNwYkRP-hANCEHOz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_869ac501-8b2a-413e-8019-109b71b75464",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bright Beginners Academy",
      "poi_type": "Education",
      "poi_address": "800 Clarmont Ave a, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-cb09-702e-9dd6-2cfd8c1cf76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cb09-702e-9dd6-2cfd8c1cf76a",
        "storage_key": "property/6767906449166317/019d0265-cb09-702e-9dd6-2cfd8c1cf76a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.brightbeginnersacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=682484905447722079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-beginners-academy",
      "poi_latitude": "40.0722586",
      "poi_longitude": "-74.9603152",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 267-520-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm7iGPbZMwYkRXwzH0WeseAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_80210392-fa29-43d6-8511-9bb9b9b014fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bensalem KinderCare",
      "poi_type": "Education",
      "poi_address": "3651 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-cd3d-7534-b652-cb293f9fefae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cd3d-7534-b652-cb293f9fefae",
        "storage_key": "property/6767906449166317/019d0265-cd3d-7534-b652-cb293f9fefae.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/bensalem/pa/301327?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3Nzc4LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=3338835342133343565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensalem-kindercare",
      "poi_latitude": "40.1246057",
      "poi_longitude": "-74.9642471",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-245-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTWhiV1NNwYkRTbVgww3tVS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_faa2213d-9f27-47f1-bdbb-a3518b979a3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bensalem Christian Day School",
      "poi_type": "Education",
      "poi_address": "4300 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-cf19-76bf-8ff7-b77ab4b49e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cf19-76bf-8ff7-b77ab4b49e5a",
        "storage_key": "property/6767906449166317/019d0265-cf19-76bf-8ff7-b77ab4b49e5a.webp",
        "width": 556,
        "height": 292
      },
      "poi_business_url": "http://www.bensalemchristiandayschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6776453786004721200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensalem-christian-day-school",
      "poi_latitude": "40.1131372",
      "poi_longitude": "-74.934449",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-245-1610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0Wgyom1NwYkRMI6pr9DMCl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_83cc6be0-71bb-4e71-b6cb-da9ca703cbc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Saint Ephrem School",
      "poi_type": "Education",
      "poi_address": "5340 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://saintephremschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7636721158261106131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-ephrem-school",
      "poi_latitude": "40.1256347",
      "poi_longitude": "-74.9278681",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-639-9488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS-tlLRhNwYkR0-Xcrm4V-2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ecbbf682-d5f4-4da4-a4f7-2752a932457f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Holy Ghost Preparatory School",
      "poi_type": "Education",
      "poi_address": "2429 Bristol Pike, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d1ee-764a-93f5-9499b5a1e0ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d1ee-764a-93f5-9499b5a1e0ca",
        "storage_key": "property/6767906449166317/019d0265-d1ee-764a-93f5-9499b5a1e0ca.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://holyghostprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3060388223648969566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-ghost-preparatory-school",
      "poi_latitude": "40.0788674",
      "poi_longitude": "-74.9458817",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-639-2102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr7jwwsJMwYkRXrNi8d-ueCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9c3ff7ca-ccb6-40a6-a6b6-fdb4e13e0d6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Parx Casino",
      "poi_type": "Entertainment",
      "poi_address": "2999 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars.",
      "poi_long_description": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d2fb-76fe-a410-bb584618c482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d2fb-76fe-a410-bb584618c482",
        "storage_key": "property/6767906449166317/019d0265-d2fb-76fe-a410-bb584618c482.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parxcasino.com/?utm_source=GoogleMyBusiness&utm_medium=GMB&utm_campaign=2019",
      "poi_directions_map_url": "https://maps.google.com/?cid=9768216460368420707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parx-casino",
      "poi_latitude": "40.1184168",
      "poi_longitude": "-74.9530825",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-588-7279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4O6WEhNwYkRYx9i0R2tj4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_5e287827-34ab-4319-aef3-6fd55fefc7f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Penn Community Bank Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "Central Park, 2400 Byberry Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d3b2-740e-836c-af5c4b7915c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d3b2-740e-836c-af5c4b7915c1",
        "storage_key": "property/6767906449166317/019d0265-d3b2-740e-836c-af5c4b7915c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pcbaevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10923894697230316793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-community-bank-amphitheater",
      "poi_latitude": "40.1072066",
      "poi_longitude": "-74.942836",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-633-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfx4SBVNwYkR-bQvkFl4mZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_a5e1ab51-7f2a-4dc8-b2fe-47ebcc0fe22c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "AMC Neshaminy 24",
      "poi_type": "Entertainment",
      "poi_address": "660 Neshaminy Mall, Bensalem, PA 19020, USA",
      "poi_short_description": "Chain multiplex featuring IMAX and Dolby sound systems, plus spacious seating and reclining chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-d637-73ae-8b5c-d66eac27b167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d637-73ae-8b5c-d66eac27b167",
        "storage_key": "property/6767906449166317/019d0265-d637-73ae-8b5c-d66eac27b167.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-neshaminy-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12053056166840425714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-neshaminy-24",
      "poi_latitude": "40.140225",
      "poi_longitude": "-74.954105",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-396-8050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3475-775f-9628-17241f2bb276.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3475-775f-9628-17241f2bb276",
        "storage_key": "property/6767906449166317/019d0266-3475-775f-9628-17241f2bb276.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRjHmK5SwYkR8txaUrkORac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_226e14fe-8020-4fe5-9aa4-2b8b284e2f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Regal UA Oxford Valley",
      "poi_type": "Entertainment",
      "poi_address": "403 Middletown Blvd, Langhorne, PA 19047, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-da26-70ca-907d-5b7ea93579b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-da26-70ca-907d-5b7ea93579b9",
        "storage_key": "property/6767906449166317/019d0265-da26-70ca-907d-5b7ea93579b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-ua-oxford-valley-1269?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17691335440541601199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-ua-oxford-valley",
      "poi_latitude": "40.185394",
      "poi_longitude": "-74.88342",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3475-775f-9628-17241f2bb276.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3475-775f-9628-17241f2bb276",
        "storage_key": "property/6767906449166317/019d0266-3475-775f-9628-17241f2bb276.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRFpuuZTwYkRr83Ct9k_hPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_73b12622-9ec6-4ef2-aff2-841cb87fd6ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Sesame Place Philadelphia",
      "poi_type": "Entertainment",
      "poi_address": "100 Sesame Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_long_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-dc1e-70eb-8330-7c70bd846dc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-dc1e-70eb-8330-7c70bd846dc5",
        "storage_key": "property/6767906449166317/019d0265-dc1e-70eb-8330-7c70bd846dc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sesameplace.com/philadelphia?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12855531197120927059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sesame-place-philadelphia",
      "poi_latitude": "40.186117",
      "poi_longitude": "-74.8729972",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 215-702-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx22iKVlRwYkRU1VYI4MFaLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_40ca9406-4ae4-4c9c-8879-53ea45d570ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bowlero Bristol",
      "poi_type": "Entertainment",
      "poi_address": "2501 Bristol Pike, Croydon, PA 19021, USA",
      "poi_short_description": "Bowling center offering arcade games and a pro shop, plus a sports bar and grill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-e091-728d-bcb5-899604b28fe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e091-728d-bcb5-899604b28fe9",
        "storage_key": "property/6767906449166317/019d0265-e091-728d-bcb5-899604b28fe9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bowlero.com/location/bowlero-bristol?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6555376967468890615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bowlero-bristol",
      "poi_latitude": "40.0977738",
      "poi_longitude": "-74.88443339999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-788-0453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7ylQdtNwYkR97nCup5g-Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_0bfbfb97-c5b3-4f69-966c-6994203719a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Lucky Strike Feasterville",
      "poi_type": "Entertainment",
      "poi_address": "100 E Street Rd, Feasterville, PA 19053, USA",
      "poi_short_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_long_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-e276-71cf-be99-f75d1c327957.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e276-71cf-be99-f75d1c327957",
        "storage_key": "property/6767906449166317/019d0265-e276-71cf-be99-f75d1c327957.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-feasterville?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=636173674674041779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-feasterville",
      "poi_latitude": "40.1504125",
      "poi_longitude": "-74.99959319999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-322-7755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-R-PBW-txokRs7NmJpYk1Ag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_905c4253-e653-493a-9a9d-a9183501fbbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Growden Mansion",
      "poi_type": "Entertainment",
      "poi_address": "5408 Neshaminy Valley Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-e50f-7529-ae13-e96ef9776f59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e50f-7529-ae13-e96ef9776f59",
        "storage_key": "property/6767906449166317/019d0265-e50f-7529-ae13-e96ef9776f59.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2473903212339728284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "growden-mansion",
      "poi_latitude": "40.1472899",
      "poi_longitude": "-74.935327",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7zXQoZNSwYkRnA81RN0RVSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_38784e65-67cc-4fc2-9508-794063858449",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Pen Ryn Estate",
      "poi_type": "Entertainment",
      "poi_address": "1601 State Rd., Bensalem, PA 19020, USA",
      "poi_short_description": "Elegant site across 100 acres, offering garden, ballroom and mansion spaces for weddings and corporate events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-e7e8-744e-ade6-d33b2e44fda0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e7e8-744e-ade6-d33b2e44fda0",
        "storage_key": "property/6767906449166317/019d0265-e7e8-744e-ade6-d33b2e44fda0.webp",
        "width": 960,
        "height": 638
      },
      "poi_business_url": "https://penrynestate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3009218790538781833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pen-ryn-estate",
      "poi_latitude": "40.0647299",
      "poi_longitude": "-74.95200439999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-633-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6X_tLBMwYkRiaR-5Yvkwik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wedding_venue"
    },
    {
      "id": "custom_f8f4611f-67e3-4ced-8d42-3b8199ab09ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "St. Mary Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Langhorne Newtown Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-ead1-72b9-be30-90f4c9702fc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ead1-72b9-be30-90f4c9702fc0",
        "storage_key": "property/6767906449166317/019d0265-ead1-72b9-be30-90f4c9702fc0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.trinityhealthma.org/st-mary?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=main-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4473732539720751236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-mary-medical-center",
      "poi_latitude": "40.2023399",
      "poi_longitude": "-74.9250062",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 215-710-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3462-73ad-8ea0-9c67c138e1b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3462-73ad-8ea0-9c67c138e1b8",
        "storage_key": "property/6767906449166317/019d0266-3462-73ad-8ea0-9c67c138e1b8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQJHP3lTwYkRhFgpwgrkFT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_117c1093-689b-452c-8f0d-48f92c6908aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Knights Medical Associates",
      "poi_type": "Health and Wellness",
      "poi_address": "3034 Knights Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-ead1-72b9-be30-8cfa2a9f0630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ead1-72b9-be30-8cfa2a9f0630",
        "storage_key": "property/6767906449166317/019d0265-ead1-72b9-be30-8cfa2a9f0630.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://knightsmedicalassociates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15074687420487792823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knights-medical-associates",
      "poi_latitude": "40.105504",
      "poi_longitude": "-74.950368",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-638-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8uFiztNwYkRt3g5_lYMNNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_1a2d289d-6e8c-4190-997b-088f042359c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "vybe urgent care",
      "poi_type": "Health and Wellness",
      "poi_address": "3626 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-ec7b-700d-b1da-449f62e1723c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ec7b-700d-b1da-449f62e1723c",
        "storage_key": "property/6767906449166317/019d0265-ec7b-700d-b1da-449f62e1723c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.vybe.care/locations/bensalem/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11089615850448209921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vybe-urgent-care",
      "poi_latitude": "40.1258298",
      "poi_longitude": "-74.9639536",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 267-763-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGf9mowhNwYkRAciBVdw65pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_5a860308-d1a3-46a5-8254-9503ed423919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Rockhill Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-f0fd-70df-86b4-6ca620594277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f0fd-70df-86b4-6ca620594277",
        "storage_key": "property/6767906449166317/019d0265-f0fd-70df-86b4-6ca620594277.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bensalem-pa-pharmacies/800-rock-hill-dr-bensalem-pa-19020/storeid=16541?WT.mc_id=LS_GOOGLE_RX_16541",
      "poi_directions_map_url": "https://maps.google.com/?cid=17388633275329244295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.1357652",
      "poi_longitude": "-74.9620225",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-364-9630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-349b-7429-b978-249c4b578337.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-349b-7429-b978-249c4b578337",
        "storage_key": "property/6767906449166317/019d0266-349b-7429-b978-249c4b578337.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5JRItxTwYkRh2yJwdXVUPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4aa7cca1-8816-46cf-80a3-0d59160014e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2435 Street Rd Walgreens, Bensalem, PA 19020, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-f1f5-75d0-8eef-e2900e757120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f1f5-75d0-8eef-e2900e757120",
        "storage_key": "property/6767906449166317/019d0265-f1f5-75d0-8eef-e2900e757120.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2435+street+rd-bensalem-pa-19020/id=6319",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548891992845295613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.1063114",
      "poi_longitude": "-74.9505671",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-639-6711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-349b-7429-b978-249c4b578337.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-349b-7429-b978-249c4b578337",
        "storage_key": "property/6767906449166317/019d0266-349b-7429-b978-249c4b578337.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7kw-jtNwYkR_Z9hTMN7XyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1cd0cb37-48e2-45a1-804e-3f8a6e05c3d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Rockhill Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "Chain health club offering group classes and personal training, plus pools and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-f579-770b-9fb4-a93c598e1a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f579-770b-9fb4-a93c598e1a2b",
        "storage_key": "property/6767906449166317/019d0265-f579-770b-9fb4-a93c598e1a2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=114&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14739770770360907803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "40.1354458",
      "poi_longitude": "-74.9584555",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-357-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3lOzahSwYkRGzgMxmsvjsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_41c67b6b-726e-4620-9d93-a85d4356a8fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1851 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Casual gym chain offering tanning, massage chairs, cardio machines and locker rooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-f56e-74a2-89d0-4903e85d9c12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f56e-74a2-89d0-4903e85d9c12",
        "storage_key": "property/6767906449166317/019d0265-f56e-74a2-89d0-4903e85d9c12.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bensalem-street-road-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18075749076340444107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.0961831",
      "poi_longitude": "-74.9428453",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-645-1181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT_TTn7lMwYkRywte-AP22fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a434971-64c5-4e7a-97f2-fda778481aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Crossfit Raid",
      "poi_type": "Health and Wellness",
      "poi_address": "309 Camer Dr #6, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-f9d9-751c-a709-85365b0b0abd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f9d9-751c-a709-85365b0b0abd",
        "storage_key": "property/6767906449166317/019d0265-f9d9-751c-a709-85365b0b0abd.webp",
        "width": 1080,
        "height": 883
      },
      "poi_business_url": "http://crossfitraid.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8875492148514659202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-raid",
      "poi_latitude": "40.0695396",
      "poi_longitude": "-74.9374022",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-390-2649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSSDtZMSyxokRghv8rhUVLHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1a94968d-3b4e-4524-b950-ed64753e5592",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Rockhill Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-f945-72d8-b77d-5f5f6c52498c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f945-72d8-b77d-5f5f6c52498c",
        "storage_key": "property/6767906449166317/019d0265-f945-72d8-b77d-5f5f6c52498c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/bensalemlafitness/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14775241566460675121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "40.1357253",
      "poi_longitude": "-74.9582047",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-279-9237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7T2hUFTwYkRMYR5D-wzDM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_874e62f4-1ed5-40b7-bba7-7dae8cddfe7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "ATI Physical Therapy",
      "poi_type": "Health and Wellness",
      "poi_address": "2641 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-fd2a-740e-8ca8-dbb545356452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-fd2a-740e-8ca8-dbb545356452",
        "storage_key": "property/6767906449166317/019d0265-fd2a-740e-8ca8-dbb545356452.webp",
        "width": 600,
        "height": 800
      },
      "poi_business_url": "https://locations.atipt.com/bensalem-pa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3224333854573806941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ati-physical-therapy",
      "poi_latitude": "40.1100206",
      "poi_longitude": "-74.9510114",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 267-525-0135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4toDjlNwYkRXUUjt44ivyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_bcbfa8b8-5637-47ce-a1f3-0b98785e13de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bensalem Township Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4301 Richlieu Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Family-friendly park with baseball fields and a playground, plus a basketball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0256-717e-8a7e-cb4e4c5991c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0256-717e-8a7e-cb4e4c5991c2",
        "storage_key": "property/6767906449166317/019d0266-0256-717e-8a7e-cb4e4c5991c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://bensalemtwp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=76002225158877826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensalem-township-community-park",
      "poi_latitude": "40.1306064",
      "poi_longitude": "-74.9407897",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-750-6855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_Ts6Z9SwYkRgvK7AJ8DDgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aba516f8-fa47-4fe8-9e3e-6cab7d2c5c78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bensalem Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0466-778d-b26f-30d75a4caa56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0466-778d-b26f-30d75a4caa56",
        "storage_key": "property/6767906449166317/019d0266-0466-778d-b26f-30d75a4caa56.webp",
        "width": 1280,
        "height": 939
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3952012176432288457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensalem-central-park",
      "poi_latitude": "40.1074925",
      "poi_longitude": "-74.9436746",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7rSiklNwYkRydJDxCJe2DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d9862666-fd10-4b0e-9794-28cc2ef99bd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Firefighters' Field Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "80 Rockhill Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "Relaxed, park-like grounds for kids and adults boasting a playground, soccer fields and workout equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-03e9-7211-a85d-51ee6b97c6ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-03e9-7211-a85d-51ee6b97c6ca",
        "storage_key": "property/6767906449166317/019d0266-03e9-7211-a85d-51ee6b97c6ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bensalempa.gov/parks.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15490993319519212385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firefighters-field-community-park",
      "poi_latitude": "40.1298227",
      "poi_longitude": "-74.9531284",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-633-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYpZ4VhNwYkRYVPka1kQ-9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fcbcc9f3-c3c6-4a61-b1be-d74d9bd46776",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Imagination Land Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3800 Hulmeville Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "Ample playground featuring swings, slides and climbing apparatus.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0692-75ec-9ef2-fdf489fdf4cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0692-75ec-9ef2-fdf489fdf4cc",
        "storage_key": "property/6767906449166317/019d0266-0692-75ec-9ef2-fdf489fdf4cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8191189315120769772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imagination-land-playground",
      "poi_latitude": "40.1075533",
      "poi_longitude": "-74.93815180000001",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6sDdBNNwYkR7Kq_h0jzrHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8492905a-0be1-4bf2-9e3e-09320984866f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "James Armstrong Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hulmeville Rd &, Washington Ln, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bensalempa.gov/parks--recreation.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2229151822924781123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-armstrong-memorial-park",
      "poi_latitude": "40.1332393",
      "poi_longitude": "-74.9195402",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-633-3614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7oPdKxTwYkRQ5bYu8WJ7x4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a81cc2a0-2aa2-4cc8-86be-4ad188a7924b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Poquessing Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Stevenson St, Philadelphia, PA 19114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0ac7-72ac-b233-39139db3b006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0ac7-72ac-b233-39139db3b006",
        "storage_key": "property/6767906449166317/019d0266-0ac7-72ac-b233-39139db3b006.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6071527637267495433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poquessing-creek-park",
      "poi_latitude": "40.0588999",
      "poi_longitude": "-74.9829172",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZPwQgCzxokRCbpLvzdmQlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83876247-051f-43b0-9acb-17385ac69e7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Newport Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "848-800 Maine Ave, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0c7e-72fa-83e7-4b902e7f072d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0c7e-72fa-83e7-4b902e7f072d",
        "storage_key": "property/6767906449166317/019d0266-0c7e-72fa-83e7-4b902e7f072d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bensalempa.gov/parks.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12215230841526365834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-park",
      "poi_latitude": "40.1190627",
      "poi_longitude": "-74.90394870000002",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cwPo75NwYkRii6TNrs3hak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f84ebd04-b4f6-4d6d-a054-903db7bc689d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Neshaminy State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 State Rd., Bensalem, PA 19020, USA",
      "poi_short_description": "This 334-acre riverfront park offers fishing, walking paths, 2 seasonal pools & picnic pavilions.",
      "poi_long_description": "This 334-acre riverfront park offers fishing, walking paths, 2 seasonal pools & picnic pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0265-de5c-70eb-a107-a7bda8331dc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-de5c-70eb-a107-a7bda8331dc8",
        "storage_key": "property/6767906449166317/019d0265-de5c-70eb-a107-a7bda8331dc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/NeshaminyStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516380802006931726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy-state-park",
      "poi_latitude": "40.0784638",
      "poi_longitude": "-74.9228603",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyQ2VlBMwYkRDlkwFISMT2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_73baf067-6c29-4fc5-a2ea-bd3a0138a8c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Benjamin Rush State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15001 Roosevelt Blvd, Philadelphia, PA 19154, USA",
      "poi_short_description": "This park offers hiking & biking paths, a community garden & a radio control model airplane field.",
      "poi_long_description": "This park offers hiking & biking paths, a community garden & a radio control model airplane field.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0de6-71f8-a9a2-8c9919203655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0de6-71f8-a9a2-8c9919203655",
        "storage_key": "property/6767906449166317/019d0266-0de6-71f8-a9a2-8c9919203655.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/BenjaminRushStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6029552078559575007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benjamin-rush-state-park",
      "poi_latitude": "40.1184473",
      "poi_longitude": "-74.9754035",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-639-4538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8xwwLeyxokR3_tCZatFrVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_fdd04a6a-c091-4ab6-a97f-b1a38b9678aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Silver Lake Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1306 Bath Rd, Bristol, PA 19007, USA",
      "poi_short_description": "This 460-acre, forested park includes a nature center with trails to explore a range of habitats.",
      "poi_long_description": "This 460-acre, forested park includes a nature center with trails to explore a range of habitats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-0ed1-73ce-8ae2-88379d0c639f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0ed1-73ce-8ae2-88379d0c639f",
        "storage_key": "property/6767906449166317/019d0266-0ed1-73ce-8ae2-88379d0c639f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.silverlakenaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=928366347596293727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-lake-nature-center",
      "poi_latitude": "40.1138601",
      "poi_longitude": "-74.8631702",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-785-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3463-76fa-8b83-e8f8d9bd0c4f",
        "storage_key": "property/6767906449166317/019d0266-3463-76fa-8b83-e8f8d9bd0c4f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcl_3gROwYkRX2bnQUY44gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0b4e65df-45c0-423f-bcfc-61c5a585368b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Cornwells Heights Train Station SEPTA Regional Rail Ticket Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "799 Station Ave, Cornwells Heights, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1372756087540330970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornwells-heights-train-station-septa-regional-rail-ticket-office",
      "poi_latitude": "40.0717011",
      "poi_longitude": "-74.9521213",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-638-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG5BPNUdNwYkR2rEYcWMCDRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a7dd4a3-f483-46a0-8901-72a3b81bbba9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Eddington",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bensalem Township, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-1376-720f-974d-0b48c975fdd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1376-720f-974d-0b48c975fdd7",
        "storage_key": "property/6767906449166317/019d0266-1376-720f-974d-0b48c975fdd7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.septa.org/stations/rail/eddington.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5903514373659759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eddington",
      "poi_latitude": "40.0828877",
      "poi_longitude": "-74.9336106",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-38fa-7248-8b15-73c45bc496cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38fa-7248-8b15-73c45bc496cf",
        "storage_key": "property/6767906449166317/019d0266-38fa-7248-8b15-73c45bc496cf.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0S4xuRMwYkRbxwrDTf5FAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e949a364-f3ae-4aa1-aeec-60309e36e861",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Croydon Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "145-161 Cedar Ave, Bristol, PA 19007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-1479-77a9-9859-f25f93731207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1479-77a9-9859-f25f93731207",
        "storage_key": "property/6767906449166317/019d0266-1479-77a9-9859-f25f93731207.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.septa.org/stations/croydon-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=6332975584239632386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "croydon-station",
      "poi_latitude": "40.09327589999999",
      "poi_longitude": "-74.9063123",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-38f5-756e-a994-f3407244af43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f5-756e-a994-f3407244af43",
        "storage_key": "property/6767906449166317/019d0266-38f5-756e-a994-f3407244af43.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJW19jqrFNwYkRAkDThb0_41c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_a68c77a6-5987-4eb0-a0f7-94dec77184f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Trevose Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1100 Boundbrook Ave, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-15cf-754f-96c3-a037c8ba785b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-15cf-754f-96c3-a037c8ba785b",
        "storage_key": "property/6767906449166317/019d0266-15cf-754f-96c3-a037c8ba785b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.septa.org/stations/trevose-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=2543916261042815329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trevose-station",
      "poi_latitude": "40.1398591",
      "poi_longitude": "-74.9853634",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-38f5-756e-a994-f3407244af43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f5-756e-a994-f3407244af43",
        "storage_key": "property/6767906449166317/019d0266-38f5-756e-a994-f3407244af43.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJLQJhzF6txokRYQHMdVzOTSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_99fe0973-a247-4be8-a300-b3da94bc1ee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Neshaminy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bensalem Township, PA 19053, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-167b-7018-8789-5afdba54c79f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-167b-7018-8789-5afdba54c79f",
        "storage_key": "property/6767906449166317/019d0266-167b-7018-8789-5afdba54c79f.webp",
        "width": 943,
        "height": 678
      },
      "poi_business_url": "http://www.septa.org/stations/rail/neshaminyfalls.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2828999010508922625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy",
      "poi_latitude": "40.1469257",
      "poi_longitude": "-74.96213399999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-38fa-7248-8b15-73c45bc496cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38fa-7248-8b15-73c45bc496cf",
        "storage_key": "property/6767906449166317/019d0266-38fa-7248-8b15-73c45bc496cf.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTy2yYbFSwYkRAd9Qg5yfQic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_2efca2e3-85e5-42cc-b8c9-cc34d64a77e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Levittown Train Station Ticket Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "8301 Bristol Pike, Levittown, PA 19054, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-1a1f-7248-824b-3bb61b67e534.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1a1f-7248-824b-3bb61b67e534",
        "storage_key": "property/6767906449166317/019d0266-1a1f-7248-824b-3bb61b67e534.webp",
        "width": 1280,
        "height": 403
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2307715567692096953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levittown-train-station-ticket-office",
      "poi_latitude": "40.1402236",
      "poi_longitude": "-74.8172687",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-946-4251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4frsnJRwYkRuSXt_hSnBiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_48da30b2-57a4-4e97-9863-c8bd76140d1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "PA Turnpike Bensalem Interchange Exit 351 (cashless)",
      "poi_type": "Transportation & Transit",
      "poi_address": "I-276 Milepost 351.5 at, U.S. Rte 1, Feasterville-Trevose, PA 19053, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-1aa6-7743-9e8e-49a5f6886d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1aa6-7743-9e8e-49a5f6886d2a",
        "storage_key": "property/6767906449166317/019d0266-1aa6-7743-9e8e-49a5f6886d2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.paturnpike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16930339113051648842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pa-turnpike-bensalem-interchange-exit-351-cashless",
      "poi_latitude": "40.1332613",
      "poi_longitude": "-74.970351",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-331-3414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyiLv6qyxokRSnNY-Lil9Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f5f0b345-7109-4734-9df6-dcfb8018c49b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Philadelphia International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8500 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_long_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-1d56-728b-95a0-a0f1c120b34c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1d56-728b-95a0-a0f1c120b34c",
        "storage_key": "property/6767906449166317/019d0266-1d56-728b-95a0-a0f1c120b34c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4480542405857629144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-international-airport",
      "poi_latitude": "39.87297969999999",
      "poi_longitude": "-75.24369870000001",
      "poi_miles_from_property": "28.9",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "2 hours 40 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 215-937-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-397d-7679-988f-9dcbc4260ee2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-397d-7679-988f-9dcbc4260ee2",
        "storage_key": "property/6767906449166317/019d0266-397d-7679-988f-9dcbc4260ee2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4OpYGbExokR2NM3RpQVLj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_2d786892-95ac-4d60-85ed-6fb720986dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Healthcare Services Group Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3220 Tillman Dr # 300, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-1d84-7132-bd02-de98a09410cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1d84-7132-bd02-de98a09410cd",
        "storage_key": "property/6767906449166317/019d0266-1d84-7132-bd02-de98a09410cd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hcsgcorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5937893291271711865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healthcare-services-group-inc",
      "poi_latitude": "40.1163186",
      "poi_longitude": "-74.9606692",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-363-4274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJheylIEpNwYkReexs9HyiZ1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_30b84227-528f-43b0-9b1a-ff352d4cef25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Neshaminy Square",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4201 Neshaminy Blvd, Bensalem, PA 19020, USA",
      "poi_short_description": "Shopping complex featuring a DMV, Mexican restaurant, and bakery, plus beauty salons.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2084-77ad-bb23-167060787819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2084-77ad-bb23-167060787819",
        "storage_key": "property/6767906449166317/019d0266-2084-77ad-bb23-167060787819.webp",
        "width": 1280,
        "height": 696
      },
      "poi_business_url": "https://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/4jt5Jdr",
      "poi_directions_map_url": "https://maps.google.com/?cid=3050089657940560180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy-square",
      "poi_latitude": "40.1355516",
      "poi_longitude": "-74.9516489",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc2-7440-9a62-0edb47d23585",
        "storage_key": "property/6767906449166317/019d0266-2fc2-7440-9a62-0edb47d23585.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPxxoR5FSwYkRNMmjQmIYVCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_38703266-6f61-4592-aa64-fc9a0a6dbf83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Jeanes Campus – Temple University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7600 Central Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2142-77b8-a4cb-b7e410b35234.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2142-77b8-a4cb-b7e410b35234",
        "storage_key": "property/6767906449166317/019d0266-2142-77b8-a4cb-b7e410b35234.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.templehealth.org/locations/jeanes-campus-tuh?utm_source=google&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8765815735638160293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jeanes-campus--temple-university-hospital",
      "poi_latitude": "40.0706545",
      "poi_longitude": "-75.08800029999999",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 215-728-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3462-73ad-8ea0-9c67c138e1b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3462-73ad-8ea0-9c67c138e1b8",
        "storage_key": "property/6767906449166317/019d0266-3462-73ad-8ea0-9c67c138e1b8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJATFVIDWxxokRpfM94fdupnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1792712a-6f2f-4c1a-98c3-7a7439338ac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Jefferson Torresdale Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10800 Knights Rd, Philadelphia, PA 19114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-23f0-74f7-8f1e-20380dc4cc83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-23f0-74f7-8f1e-20380dc4cc83",
        "storage_key": "property/6767906449166317/019d0266-23f0-74f7-8f1e-20380dc4cc83.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/torresdale-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9542901406483818775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-torresdale-hospital",
      "poi_latitude": "40.0714928",
      "poi_longitude": "-74.9825341",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-612-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3462-73ad-8ea0-9c67c138e1b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3462-73ad-8ea0-9c67c138e1b8",
        "storage_key": "property/6767906449166317/019d0266-3462-73ad-8ea0-9c67c138e1b8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe5FyJESzxokRFykLzEQyb4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b4f91e8d-12f7-44ca-89b0-24037e5eedd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Woods Services and Woods System of Care",
      "poi_type": "Major Employers & Offices",
      "poi_address": "40 Martin Gross Dr, Langhorne, PA 19047, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2494-7162-ac3c-90ecb06aad48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2494-7162-ac3c-90ecb06aad48",
        "storage_key": "property/6767906449166317/019d0266-2494-7162-ac3c-90ecb06aad48.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://www.woods.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4528934966245223408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woods-services-and-woods-system-of-care",
      "poi_latitude": "40.1749946",
      "poi_longitude": "-74.9081778",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-750-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2fc8-7458-9913-4872dc930c7c",
        "storage_key": "property/6767906449166317/019d0266-2fc8-7458-9913-4872dc930c7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYMYJaVTwYkR8GvkQVsC2j4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a2b3479a-b01a-4435-b0e1-d648688fc43d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "poi_name": "Bensalem School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3000 Donallen Dr, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bensalemsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3985800841806758040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bensalem-school-district",
      "poi_latitude": "40.1416153",
      "poi_longitude": "-74.92576380000001",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-750-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3006-746b-8785-6cfb6c987c78",
        "storage_key": "property/6767906449166317/019d0266-3006-746b-8785-6cfb6c987c78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzyHdPYlSwYkRmEBYeb9oUDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_0d528d01-14ae-414a-80e7-575f6a2e6600",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_705ca15c-5833-43c2-a551-36f3c59473e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_38fc4f2b-08ac-454a-8802-268807a5a1a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ae50bcf0-6bd7-44d2-a957-aa1a81459110",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2dc67173-a304-46ed-b456-1cff8ec04551",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d06955e1-c93f-45eb-9512-7fba17663ddf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_55da68dc-a248-4d82-a9aa-99ac6c031059",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "I am thrilled with my experience with this staff. The office staff is incredibly helpful and genuine. Especially Brianna. She went Above and beyond to make sure I had everything I needed for my move in. The maintenance staff is polite and helpful when needed. The apartment it’s self is tidy, cozy and very fresh looking. All in all... A    for Franklin commons.",
      "date": "",
      "title": "LOVE THIS PLACE"
    },
    {
      "id": "custom_7e9cce66-ab42-4fa5-b1f1-22fc4f4216de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "Best place I have lived! This has it all, it has great employees that care for there tenants. They are quick to get issues resolved for maintenance and they remember who you are. I walk into the office and they ask me how my day is by name it's a very welcoming community. It's very animal friendly and the neighbors are really nice. The space is awesome, my one bedroom apartment is 850 sq feet! It's awesome and my dog loves it here too. I am perfectly happy, the pool is an Olympic size pool, it is close to 3 different malls and a ton of places to eat. A movie theater is near by at one of the malls too. It is great, a 5 minuet drive and you will be where all the shopping centers are!",
      "date": "",
      "title": "Franklin Commons"
    },
    {
      "id": "custom_830d4ad8-35af-4f5a-ac7c-52ea19014914",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "Have been living here for more than 3 years now, and I have wonderful experience. Friendly staff (Amanda is awesome), maintenance done within an hour or two from the request time, plenty of parking spaces, big living rooms etc are some highlights. Although not big fan of paying for Valet trash but not a deal breaker.\nI opted-in for regular non-upgraded apartment so appliances were little worn out even from the beginning. I like this place so I will try to move to upgraded model for next year.\n\nGym is awesome addition but some additional equipments and little more cleanliness could make experience even better. \nNot having Verizon option for Comcast is the my only complaint.\n\nI highly recommend this apartment for anyone looking for a good apartment package as a whole. I don't know why people have bad reviews.",
      "date": "",
      "title": "Nice staffs, super quick maintenance, spacious place, lot of features"
    },
    {
      "id": "custom_a672f23d-fd43-4ad3-824a-30ad743aaa8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "I absolutely love my apartment at Franklin Commons! The 4 years I have lived here have been great. I love all the people and how are complex is set up and my cute apartment. I wish to spend many more years here as long as I can afford it!!",
      "date": "",
      "title": "Franklin Commons is great!"
    },
    {
      "id": "custom_9dd15a64-b5fa-40d2-8a7a-7f20fd93ddca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "I love this apartment.  It is almost like living in a house.  There is a window in every room.  The view from my back patio is a huge yard.  The neighborhood kids play football out there.  The windows are nice and big.  My cats love to sit in the window and look at the birds.  Another good thing about this apartment is that there is a gym that I can go to anytime.  There is a beautiful pool where me and my guests can swim.  I was looking at condos and my apartment is just as nice, even nicer than some.  I decided to rent because I don't like to shovel snow and am not good at maintaining the grounds like they do at my apartment.  If something breaks down, they come to fix it right away and if it can't be fixed, they replace it right away.  I live on the 1st floor so there are bugs sometimes when the weather gets cold.  The exterminator comes at the exact time he says he will.  There is no long wait.  Another good thing about this apartment is that it is at a good location.  It is near all the fast food and chain restaurants.  I 95 and the Turnpike are also close by.  I plan on staying here until I die or have to go to a nursing home.  Whichever comes first.  This is the greatest place to live.",
      "date": "",
      "title": "Almost like a house"
    },
    {
      "id": "custom_3e11857e-3888-4251-aaa5-8c165d03b4f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "Frankin Commons is awesome. The staff is very helpful and friendly! Dave showed me two apartments, both which were in my budget range. We went back to the office and within 24 hours I had an approval and he was very efficient and helpful. They were even flexible with my move in date, knowing my old apartment lease was coming to an end. They were very quick with my maintenance request too, I had 3 major issues when I moved in and they came out right away to fix all the issues. The best part is that they are dog friendly, I couldn't find a place that accepted big dogs, but Franklin Commons does! They are all over and it is awesome to see such a pet friendly community! I love it here, it's also very quiet and the neighbors are friendly as well! I am very happy to call Franklin Commons my home.",
      "date": "",
      "title": "Franklin Commons"
    },
    {
      "id": "custom_0054812d-9c6c-4496-b754-6ef052bf787a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "This is the best apartment . The office staff especially Elisa go above and beyond to help you and resolve any issues. The maintence staff is quick and very efficient . They come out promptly and work very hard to fix the promptly . My Ac unit needed to be replaced and of course it's the hottest week it breaks down too . Jose and coworker ( I wish I knew his name) worked from early in the morning till the end of their work day to make sure that I had air . I can't give the staff enough praise",
      "date": "",
      "title": "Outstanding staff and apt"
    },
    {
      "id": "custom_66bfa4db-cc52-478b-beed-fba818e822f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "rating": "5.0",
      "name": "",
      "text": "Elisa in the office is excellent to work with. I can't praise her enough. The move in was smooth. I needed things looked at and maintience was there the next day. Plenty of parking as well.",
      "date": "",
      "title": "Best decision ever"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bd15a0f0-bbc0-4cf7-84e9-eb42e52622c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/019fa498-7fd3-72cb-9ddf-435579b437fd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa498-7fd3-72cb-9ddf-435579b437fd",
        "storage_key": "property/6767906449166317/019fa498-7fd3-72cb-9ddf-435579b437fd.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " Franklin Commons",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=635bfed86a0059102d1cb298&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_08b413291b6bf92f1e5330ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429500",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6013ba4eaffed71620215d36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429502",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8fe4234f2c36cee00413e73e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429503",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_7329b579b368d3e5a5509826",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429504",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "350.00 / 150.00",
      "amount_type": "text",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_541b1d6a79fa8a6408bb1fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429505",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_157ea7d691320a9139fb0cf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429507",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_34e980e33cb89cd1d81c248f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "429512",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_422840bda40650b9731fb5f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "536753",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_37c1938664b4ed9a731127ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "536756",
      "name": "Valet Trash",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8c7015779da8c90919e70e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "536757",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_535cd3e6c66b5c9c5b59ca2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "543112",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_06fd227c5bdd083981cc059e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "543118",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_64cbf8271116d12fa8014b7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "543119",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7e2f1e721d65a40b57321028",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "835253",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fa9da396d9462e1cd0f985fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "835256",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9d151a845e83249092ef9445",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "835258",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1d7b242842a8b0e7e41895be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "835259",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1245e8738bea9a8698133380",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "engrain",
      "external_id": "835260",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a31a8-3dbd-700a-ab45-324a8005df0d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Franklin Commons Apartments property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317"
    },
    {
      "lead_collector_id": "019c3043-4d06-70e8-8774-6bac5f2a230f",
      "lead_source": "FACEBOOK_ADS",
      "name": "franklin-commons",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317"
    },
    {
      "lead_collector_id": "019c3043-4d76-775d-9449-27a5331ae7b2",
      "lead_source": "LANDING_PAGE",
      "name": "franklin-commons",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-bensalem-pa-158",
      "search_query": "pet friendly apartments bensalem pa",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Bensalem, PA",
      "h2_subtitle": "Discover the perfect pet-friendly community in Bensalem. Franklin Commons Apartments offers ideal living spaces for pet owners.",
      "page_copy": "If you're seeking pet friendly apartments in Bensalem, PA, Franklin Commons Apartments is the ideal choice. Our community warmly welcomes furry family members, providing extensive amenities including a dedicated dog park. Enjoy modern, spacious floor plans available in one or two-bedroom options, perfectly designed for you and your pet's comfort.\n\nFranklin Commons is more than just pet friendly; it’s a vibrant community in Bensalem. Join engaging resident activities and utilize convenient features such as our fitness center and laundry center. Experience the joy of living in a pet-friendly atmosphere where community bonds and lifestyle convenience blend seamlessly. Visit us to experience the welcoming environment we offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Bensalem, PA",
      "seo_description": "Find pet-friendly apartments in Bensalem, PA, at Franklin Commons. Enjoy modern living spaces and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartments-with-fitness-center-bucks-county-475",
      "search_query": "apartments with fitness center bucks county",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Bucks County",
      "h2_subtitle": "Explore Franklin Commons Apartments, offering a modern fitness center in Bucks County and vibrant living spaces.",
      "page_copy": "Looking for apartments with a fitness center in Bucks County? Franklin Commons Apartments in Bensalem is your top choice. Our state-of-the-art fitness center is designed to cater to your active lifestyle, helping you hit your health goals right at home. Choose from stylish one or two-bedroom layouts that complement your workout routine and everyday life.\n\nNestled in the heart of Bucks County, Franklin Commons offers more than just fitness-focused amenities. Enhance your lifestyle with our serene dog park, engaging resident activities, and modern conveniences like washers and dryers in each unit. Our community fosters a vibrant and welcoming atmosphere, where fitness and companionship thrive together. Come see how we can transform your living experience!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center, Bucks County",
      "seo_description": "Discover Franklin Commons in Bucks County, offering apartments with a modern fitness center, and enjoy a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "dog-park-apartments-bensalem-267",
      "search_query": "dog park apartments bensalem",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Bensalem",
      "h2_subtitle": "Franklin Commons Apartments offers a dog-friendly haven with a dedicated dog park in Bensalem. Ideal for pet lovers.",
      "page_copy": "If you're searching for dog park apartments in Bensalem, Franklin Commons Apartments is the perfect fit! Our community proudly features a dedicated dog park, providing a safe and engaging space for your furry friends to play and socialize. With spacious one and two-bedroom floor plans, our apartments offer a pet-friendly environment that suits every lifestyle.\n\nAt Franklin Commons, nestled in the heart of Bensalem, PA, pet owners not only enjoy our dog park, but also various community amenities. Participate in our vibrant resident activities, and enjoy modern conveniences such as in-unit washers and dryers and a state-of-the-art fitness center. Experience an inclusive and dynamic community living where pets are truly part of the family. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Bensalem",
      "seo_description": "Find your ideal home at Franklin Commons in Bensalem, featuring a community with a dedicated dog park. Perfect for dog lovers and their furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartments-with-pools-bensalem-pa-635",
      "search_query": "apartments with pools bensalem pa",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Bensalem, PA",
      "h2_subtitle": "Experience relaxed living at Franklin Commons Apartments in Bensalem. Although we offer no pool, our vibrant amenities create a perfect community.",
      "page_copy": "While Franklin Commons Apartments in Bensalem, PA, does not feature a swimming pool, we offer a range of other exceptional amenities that ensure a rewarding living experience. Dive into our state-of-the-art fitness center, take part in engaging resident activities, or unwind in our serene dog park—all tailored to cultivate a vibrant community atmosphere.\n\nChoose from our modern one or two-bedroom apartments, each designed with comfort and convenience in mind, featuring in-unit washers and dryers as well as a well-maintained laundry center. Located in the heart of Bucks County, Franklin Commons provides a welcoming neighborhood environment that suits any lifestyle. Schedule a tour today and explore how our amenities can enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Bensalem, PA",
      "seo_description": "Franklin Commons offers lively community amenities in Bensalem. While there’s no pool, find comfort and leisure in other exceptional features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-bensalem-442",
      "search_query": "in unit laundry apartments bensalem",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Bensalem",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Franklin Commons Apartments, located in Bensalem. Modern and hassle-free living awaits!",
      "page_copy": "For those seeking in-unit laundry apartments in Bensalem, Franklin Commons Apartments offers the perfect solution. Enjoy the convenience of having a washer and dryer in your own apartment, making laundry day a breeze. Our thoughtfully designed one and two-bedroom floor plans ensure comfort and functionality, aligning with your modern lifestyle.\n\nLocated in the vibrant community of Bensalem, PA, Franklin Commons provides various amenities beyond in-unit laundry. Enjoy access to our fitness center, participate in community-focused resident activities, and let your pet enjoy the dedicated dog park. Experience the blend of comfort and convenience at Franklin Commons, where your ideal home awaits. Schedule a visit today to see how we can enhance your daily living!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments, Bensalem",
      "seo_description": "Enjoy the convenience of in-unit laundry at Franklin Commons Apartments in Bensalem. Modern, comfortable living designed for you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-bensalem-pa-236",
      "search_query": "one bedroom apartments bensalem pa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Bensalem, PA",
      "h2_subtitle": "Explore stylish one-bedroom apartments at Franklin Commons in Bensalem, PA. Perfect for singles or couples seeking modern living.",
      "page_copy": "Looking for one-bedroom apartments in Bensalem, PA? Franklin Commons Apartments offers a range of stylish units designed to meet modern needs. Our one-bedroom floor plans are perfect for singles or couples who value both comfort and efficiency, providing a welcoming environment right in the heart of Bensalem.\n\nBeyond the walls of your apartment, Franklin Commons provides access to a variety of community amenities. From enjoying resident activities and staying active in our state-of-the-art fitness center to taking your furry friend to the serene dog park, you'll find numerous ways to connect and unwind. Discover the perfect blend of convenience and community today by scheduling a tour of Franklin Commons Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Bensalem, PA",
      "seo_description": "Discover modern one-bedroom apartments at Franklin Commons in Bensalem, PA. Ideal for singles or couples seeking comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-bucks-county-530",
      "search_query": "two bedroom apartments bucks county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bucks County",
      "h2_subtitle": "Find spacious two-bedroom apartments at Franklin Commons in Bensalem, located right in the vibrant Bucks County community. Perfect for families or roommates.",
      "page_copy": "Searching for two-bedroom apartments in Bucks County? Franklin Commons Apartments in Bensalem is the ideal choice for families or roommates seeking ample living space and modern amenities. Our thoughtfully designed two-bedroom floor plans offer plenty of room to live, work, and relax within the bustling community of Bucks County.\n\nResidents at Franklin Commons enjoy a wealth of amenities, including a fitness center, engaging resident activities, and a tranquil dog park. With an in-unit washer and dryer, as well as a convenient laundry center, our apartments are designed for easy and efficient living. Experience the comfort and community spirit Franklin Commons provides by scheduling a tour today. Discover why our two-bedroom apartments are the perfect fit for your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments, Bucks County",
      "seo_description": "Explore spacious two-bedroom apartments at Franklin Commons in the vibrant community of Bucks County. Ideal for families or roommates.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartments-near-robert-k-shafer-middle-school-312",
      "search_query": "apartments near robert k shafer middle school bensalem",
      "category": "School",
      "h1_title": "Apartments Near Robert K. Shafer Middle School",
      "h2_subtitle": "Discover convenient living at Franklin Commons Apartments, located near Robert K. Shafer Middle School in Bensalem. Ideal for families and educators.",
      "page_copy": "Families and educators seeking apartments near Robert K. Shafer Middle School in Bensalem will find Franklin Commons Apartments to be the perfect fit. Our community offers one and two-bedroom floor plans tailored for modern living and provides easy access to nearby schools, making it an ideal location for families prioritizing education.\n\nFranklin Commons Apartments enhance your lifestyle with a host of amenities, including an on-site fitness center, vibrant resident activities, and a dog park for your pets. Each apartment is designed with convenience in mind, featuring amenities such as in-unit washers and dryers. Experience the blend of community spirit and modern comfort at Franklin Commons by scheduling a tour today. Discover why our location near schools and community amenities make it a top choice for Bensalem residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Robert K. Shafer Middle School",
      "seo_description": "Find convenient living at Franklin Commons Apartments near Robert K. Shafer Middle School in Bensalem. Perfect for families and educators.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "franklin-commons-apts-near-cecelia-snyder-ms-517",
      "search_query": "franklin commons apts close to cecelia snyder middle school",
      "category": "School",
      "h1_title": "Franklin Commons Apts Near Cecelia Snyder MS",
      "h2_subtitle": "Live comfortably at Franklin Commons Apartments, conveniently located near Cecelia Snyder Middle School in Bensalem. Perfect for families seeking convenience.",
      "page_copy": "For families looking for proximity to Cecelia Snyder Middle School, Franklin Commons Apartments in Bensalem offers an ideal location. Our community provides stylish one or two-bedroom apartments suitable for those prioritizing education and convenience. Being close to local schools adds an extra layer of ease for busy families and educators alike.\n\nFranklin Commons isn't just about location; it's about lifestyle. Residents enjoy modern amenities including a fitness center, diverse resident activities, and a delightful dog park for furry family members. Each apartment features conveniences such as washers, dryers, and AION renovation details, making them as functional as they are comfortable. Ensure your family's best interests by choosing Franklin Commons Apartments—schedule a tour today and see how our vibrant community aligns with your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Franklin Commons Apts Near Cecelia Snyder MS",
      "seo_description": "Discover Franklin Commons Apartments near Cecelia Snyder Middle School in Bensalem. Perfect location and amenities for families and educators.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "bensalem-rentals-benjamin-rush-elementary-781",
      "search_query": "bensalem rentals by benjamin rush elementary school",
      "category": "School",
      "h1_title": "Bensalem Rentals Near Benjamin Rush Elementary",
      "h2_subtitle": "Find family-friendly rentals at Franklin Commons Apartments, conveniently located near Benjamin Rush Elementary School in Bensalem.",
      "page_copy": "Franklin Commons Apartments in Bensalem offers a prime location for families seeking rentals near Benjamin Rush Elementary School. Our community features spacious one and two-bedroom apartments that are perfect for families prioritizing education and convenience.\n\nAt Franklin Commons, you'll enjoy a host of amenities, from a well-equipped fitness center and engaging resident activities to a serene dog park. Each apartment is designed with modern living in mind, featuring in-unit washers and dryers for added convenience. With its blend of comfort and community spirit, Franklin Commons is a superb choice for those with children attending Benjamin Rush Elementary. Schedule a tour today and explore all the benefits of living in this vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bensalem Rentals Near Benjamin Rush Elementary",
      "seo_description": "Explore Franklin Commons rentals near Benjamin Rush Elementary School in Bensalem. Perfect for families seeking convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "properties-near-bensalem-high-school-103",
      "search_query": "properties by bensalem high school",
      "category": "School",
      "h1_title": "Properties Near Bensalem High School",
      "h2_subtitle": "Discover the ideal living environment at Franklin Commons Apartments, conveniently situated near Bensalem High School. Perfect for students and families.",
      "page_copy": "Franklin Commons Apartments offer exceptional properties near Bensalem High School, ideal for both families and students. Our modern one and two-bedroom floor plans provide a comfortable and convenient lifestyle with easy access to educational facilities.\n\nOur community enhances living through a variety of amenities, including an on-site fitness center, engaging resident activities, and a dog park for pet lovers. Each apartment features conveniences like washers and dryers, making daily life seamless. Experience the vibrant community spirit at Franklin Commons Apartments, where proximity to Bensalem High School adds significant value to your living experience. Schedule a visit today and discover why our properties are highly sought after in Bensalem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Properties Near Bensalem High School",
      "seo_description": "Discover Franklin Commons Apartments near Bensalem High School. Ideal properties for students and families seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "modern-living-near-russell-c-struble-elementary-627",
      "search_query": "modern living near russell c struble elementary bensalem",
      "category": "School",
      "h1_title": "Modern Living Near Russell C Struble Elementary",
      "h2_subtitle": "Franklin Commons Apartments offer modern living just a stone's throw from Russell C Struble Elementary in Bensalem. Ideal for families seeking convenience.",
      "page_copy": "Experience contemporary living at Franklin Commons Apartments, perfectly situated near Russell C Struble Elementary School in Bensalem. Our thoughtfully designed one and two-bedroom apartments cater to families who prioritize living close to educational institutions while enjoying the best of modern amenities.\n\nResidents at Franklin Commons enjoy access to a range of exceptional facilities designed to enhance their lifestyle. From a fully-equipped fitness center and a vibrant resident activities calendar to a delightful dog park, every amenity is crafted with your comfort in mind. Each apartment features washers, dryers, and AION renovations, ensuring both functionality and style. Discover a community where modern living and educational convenience converge—schedule a tour today and see firsthand the benefits of living at Franklin Commons Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Living Near Russell C Struble Elementary",
      "seo_description": "Discover Franklin Commons Apartments offering modern living near Russell C Struble Elementary in Bensalem. Perfect for families seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartment-homes-near-saint-ephrem-school-986",
      "search_query": "apt homes near saint ephrem school pa",
      "category": "School",
      "h1_title": "Apartment Homes Near Saint Ephrem School",
      "h2_subtitle": "Find inviting apartment homes at Franklin Commons, ideally located near Saint Ephrem School in PA. Enjoy a family-friendly community.",
      "page_copy": "Franklin Commons Apartments provides charming apartment homes just minutes away from Saint Ephrem School, making it an excellent choice for families in Bensalem, PA. With easy access to the school, our community offers modern one and two-bedroom floor plans tailored for family needs.\n\nEnhance your lifestyle with our variety of amenities, which include a fitness center, active resident community activities, and a dog park. Each apartment comes with a washer and dryer, along with the benefit of our AION renovations, ensuring a modern touch throughout. With its family-friendly environment and stellar location, Franklin Commons Apartments is a top pick for those seeking proximity to educational facilities like Saint Ephrem School. Schedule your tour today to explore these delightful apartment homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Saint Ephrem School",
      "seo_description": "Explore Franklin Commons Apartments near Saint Ephrem School, PA. Perfect apartment homes for families seeking modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "living-near-holy-ghost-preparatory-school-366",
      "search_query": "living by holy ghost preparatory school bucks county",
      "category": "School",
      "h1_title": "Living Near Holy Ghost Preparatory School",
      "h2_subtitle": "Franklin Commons offers prime living options near Holy Ghost Preparatory School in Bucks County. Perfect for students and educational professionals.",
      "page_copy": "Discover an optimal living experience at Franklin Commons Apartments, conveniently located near Holy Ghost Preparatory School in Bucks County. Our community is perfect for students and educational staff seeking proximity to this esteemed institution while enjoying modern living conditions.\n\nOur one and two-bedroom apartments are designed to provide comfort and ease, featuring amenities like in-unit washers and dryers, and AION renovations. Residents here benefit from a state-of-the-art fitness center, engaging resident activities, and a welcoming dog park, making Franklin Commons an enriching place to live. Whether you're connected to Holy Ghost Prep or simply value its proximity, our apartments offer an ideal combination of location and lifestyle in Bucks County. Schedule a tour today and see what makes our community so special.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Holy Ghost Preparatory School",
      "seo_description": "Live at Franklin Commons Apartments, near Holy Ghost Preparatory School in Bucks County. Ideal for students and staff seeking a modern lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartments-near-st-mary-medical-center-409",
      "search_query": "apartments near St. Mary Medical Center Bucks County",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Mary Medical Center",
      "h2_subtitle": "Discover apartments close to St. Mary Medical Center in Bucks County at Franklin Commons. Ideal for medical professionals seeking convenience.",
      "page_copy": "Franklin Commons Apartments offers an excellent living arrangement for those seeking proximity to St. Mary Medical Center in Bucks County. Perfect for healthcare professionals and employees looking for a convenient home base, our community combines ease of access with modern living.\n\nOur one and two-bedroom floor plans boast a variety of amenities, including in-unit washers and dryers, refreshed AION renovations, and inviting community spaces like a fitness center and a serene dog park. Engage with fellow residents through vibrant activities designed to create lasting connections. With its desirable location near St. Mary Medical Center, Franklin Commons provides an ideal spot for those in the medical field who prioritize both location and lifestyle. Schedule a visit today to explore our welcoming apartments and experience the convenience firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Mary Medical Center",
      "seo_description": "Find Franklin Commons Apartments near St. Mary Medical Center in Bucks County. Ideal for medical staff seeking a convenient and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartments-near-bensalem-township-park-194",
      "search_query": "apartments near Bensalem Township Community Park",
      "category": "Park",
      "h1_title": "Apartments Near Bensalem Township Park",
      "h2_subtitle": "Explore Franklin Commons, located just a short distance from Bensalem Township Community Park. Enjoy outdoor activities and modern living.",
      "page_copy": "Franklin Commons Apartments in Bensalem, PA, presents an ideal living experience for those who cherish nature and outdoor leisure. Located conveniently near Bensalem Township Community Park, our community places you just minutes from this beautiful recreational area.\n\nChoose from our thoughtfully designed one and two-bedroom apartments featuring comforts such as in-unit washers and dryers, and stylish AION renovations. Beyond your apartment, enjoy amenities including a fitness center, various resident activities, and a pet-friendly dog park. The park provides a fantastic spot for weekend activities or a serene walk in nature. With our proximity to Bensalem Township Community Park, Franklin Commons is perfect for those who desire a modern living environment paired with natural escapes. Book a tour with us today and see the harmony of convenience and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bensalem Township Park",
      "seo_description": "Live at Franklin Commons, near Bensalem Township Community Park. Ideal apartments for those who enjoy outdoor activities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "bensalem-apartments-near-central-park-317",
      "search_query": "Bensalem apartments by Bensalem Central Park",
      "category": "Park",
      "h1_title": "Bensalem Apartments by Central Park",
      "h2_subtitle": "Discover Franklin Commons, perfectly situated near Bensalem Central Park. Enjoy modern living with easy access to outdoor adventures.",
      "page_copy": "At Franklin Commons Apartments, modern conveniences meet natural beauty in the heart of Bensalem, PA. Ideally located near Bensalem Central Park, our community offers residents both a tranquil escape and easy access to outdoor recreational activities.\n\nSelect from our distinctive one and two-bedroom apartment layouts, each offering up-to-date amenities like in-unit washers and dryers, and elegant AION renovations. Our residents benefit from a fitness center, vibrant resident activities, and a welcoming dog park - perfect for pet owners. Bensalem Central Park, just a stone's throw away, provides an excellent setting for leisurely walks and community events. Whether you love outdoor activities or prefer a vibrant community atmosphere, living near Bensalem Central Park at Franklin Commons assures you the best of both worlds. Schedule your tour today and discover your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bensalem Apartments by Central Park",
      "seo_description": "Find Franklin Commons Apartments near Bensalem Central Park. Ideal for those who appreciate modern living with great outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "franklin-commons-near-firefighters-field-park-370",
      "search_query": "Franklin Commons near Firefighters' Field Community Park",
      "category": "Park",
      "h1_title": "Franklin Commons Near Firefighters' Field Park",
      "h2_subtitle": "Experience the perfect blend of modern living at Franklin Commons, conveniently located near Firefighters' Field Community Park.",
      "page_copy": "Located in Bensalem, PA, Franklin Commons Apartments offers a unique blend of comfort, style, and location. Situated close to Firefighters' Field Community Park, our community is ideal for those who enjoy outdoor activities and natural beauty.\n\nChoose from our spacious one or two-bedroom floor plans featuring modern conveniences such as in-unit washers and dryers, and renovated interiors with AION upgrades. Residents can take advantage of communal amenities like a fitness center, dog park, and engaging resident activities. The nearby Firefighters' Field Community Park provides a perfect escape for relaxation and recreational activities, making it a favored spot for afternoon walks or weekend picnics. Embrace a lifestyle combining the vitality of outdoor spaces with the conveniences of contemporary living by choosing Franklin Commons as your next home. Contact us today to schedule a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Franklin Commons by Firefighters' Field Park",
      "seo_description": "Live at Franklin Commons, close to Firefighters' Field Community Park. Enjoy modern living with easy access to outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "imagination-land-near-bucks-county-rentals-550",
      "search_query": "imagination land playground near rentals in Bucks County",
      "category": "Park",
      "h1_title": "Imagination Land Playground Near Bucks Rentals",
      "h2_subtitle": "Discover Franklin Commons in Bucks County, with easy access to the vibrant Imagination Land Playground. Ideal for families seeking comfort and fun.",
      "page_copy": "Franklin Commons Apartments, nestled in the vibrant Bucks County, PA, community, offers an unrivaled living experience near the delightful Imagination Land Playground. Perfectly located for families and individuals who cherish both indoor comfort and outdoor enjoyment.\n\nOur stylish one and two-bedroom apartments feature modern amenities such as in-unit washers and dryers and beautifully upgraded AION renovations. Residents partake in engaging activities, enjoy the fitness center, or relax in our pet-friendly dog park. The nearby Imagination Land Playground offers endless fun for families and children, ensuring there's always something to do outside. With its unique location in Bucks County, Franklin Commons provides a harmonious blend of family-friendly amenities and the excitement of Imagination Land Playground. Book a tour today and discover the leisure and vibrancy that await you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Imagination Land Near Bucks County Rentals",
      "seo_description": "Explore Franklin Commons in Bucks County, near Imagination Land Playground. Perfect rentals for a modern lifestyle and family fun.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "living-near-james-armstrong-park-bensalem-286",
      "search_query": "places to live by James Armstrong Memorial Park Bensalem",
      "category": "Park",
      "h1_title": "Live Near James Armstrong Park Bensalem",
      "h2_subtitle": "Franklin Commons is a top choice for those seeking a home near James Armstrong Memorial Park. Enjoy easy access to park amenities and vibrant community life.",
      "page_copy": "For anyone looking for an ideal place to live in Bensalem, PA, Franklin Commons Apartments offers a perfect location near James Armstrong Memorial Park. This modern community blends contemporary comfort and convenient access to nature and recreational activities.\n\nResidents choose from spacious one and two-bedroom floor plans, equipped with amenities such as in-unit washers and dryers and stylish AION renovations. Community features include a fitness center, active resident events, and a serene dog park. Proximity to James Armstrong Memorial Park means you have a great venue for jogging, family picnics, or simply enjoying a breath of fresh air right at your doorstep. Experience the vibrancy and convenience of living near one of Bensalem's premier parks by making Franklin Commons your next home. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near James Armstrong Park Bensalem",
      "seo_description": "Discover Franklin Commons, a perfect place to live near James Armstrong Memorial Park in Bensalem, with modern amenities and outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "poquessing-creek-park-nearby-apartments-19020-351",
      "search_query": "Poquessing Creek Park nearby apartments 19020",
      "category": "Park",
      "h1_title": "Apartments Near Poquessing Creek Park 19020",
      "h2_subtitle": "Find your perfect home at Franklin Commons, offering modern living close to the serenity of Poquessing Creek Park in the 19020 area.",
      "page_copy": "Franklin Commons Apartments are ideally situated in Bensalem, PA, only a short distance from the scenic Poquessing Creek Park. Our community provides a perfect blend of modern living and easy access to one of the area's renowned natural attractions.\n\nChoose from our variety of one and two-bedroom floor plans, each featuring contemporary interiors with in-unit washers and dryers and state-of-the-art AION renovations. Community amenities include a fitness center, engaging resident activities, and a welcoming dog park. Poquessing Creek Park is just minutes away, offering a peaceful retreat for hiking, picnicking, or simply enjoying the natural beauty of the area. Experience the blend of tranquility and modern convenience by choosing Franklin Commons as your next home. Contact us today to learn more and schedule a visit!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Poquessing Creek Park 19020",
      "seo_description": "Discover Franklin Commons Apartments, conveniently located near Poquessing Creek Park in the 19020 area. Enjoy modern amenities close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "newport-park-nearby-bensalem-rentals-759",
      "search_query": "Newport Park nearby Bensalem rentals",
      "category": "Park",
      "h1_title": "Bensalem Rentals Near Newport Park",
      "h2_subtitle": "Discover a vibrant community at Franklin Commons Apartments, offering easy access to Newport Park and top-tier amenities for every lifestyle.",
      "page_copy": "Looking for a new home with access to green spaces? Franklin Commons Apartments in Bensalem offers ideal rentals close to the picturesque Newport Park. Our vibrant community ensures both comfort and convenience with modern amenities.\n\nChoose from thoughtfully designed one and two-bedroom apartments featuring in-unit washers and dryers and premium AION renovations. Residents enjoy a fully equipped fitness center, a lively schedule of activities, and a pet-friendly dog park. Newport Park, just nearby, provides a scenic refuge for outdoor activities such as jogging, playing with kids, or simply unwinding in nature. Franklin Commons combines the appeal of modern living with the tranquility of nearby Newport Park. Schedule a tour today and find your perfect home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bensalem Rentals Near Newport Park",
      "seo_description": "Explore Franklin Commons Apartments, offering modern living just moments from Newport Park in Bensalem. Perfect rentals for comfort and outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "neshaminy-state-park-near-bensalem-apartments-327",
      "search_query": "Neshaminy State Park near Bensalem apartments",
      "category": "Park",
      "h1_title": "Apartments Near Neshaminy State Park Bensalem",
      "h2_subtitle": "Experience prime living at Franklin Commons, located near Neshaminy State Park. Enjoy outdoor activities along with exceptional community features.",
      "page_copy": "Find your dream apartment at Franklin Commons, conveniently located near Neshaminy State Park in Bensalem, PA. Our community offers the perfect blend of modern comforts and easy access to outdoor adventures.\n\nFranklin Commons boasts stylish one and two-bedroom floor plans equipped with in-unit washers and dryers and luxurious AION renovations. Our residents enjoy a range of amenities including a fitness center, vibrant resident activities, and a welcoming dog park. With Neshaminy State Park just a short trip away, you can take advantage of scenic walks, picnics by the water, and many outdoor activities. Embrace a lifestyle enriched by nature and modern convenience at Franklin Commons. Book a tour today to see why this is the perfect place to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Neshaminy State Park Bensalem",
      "seo_description": "Discover Franklin Commons in Bensalem, offering stylish apartments near Neshaminy State Park with easy access to outdoor activities and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "bensalem-apartments-close-to-benjamin-rush-state-park-462",
      "search_query": "Bensalem apartments close to Benjamin Rush State Park",
      "category": "Park",
      "h1_title": "Bensalem Apartments Near Benjamin Rush Park",
      "h2_subtitle": "Franklin Commons offers stylish living in Bensalem, just a short drive from Benjamin Rush State Park, combining outdoor access with modern amenities.",
      "page_copy": "Discover the perfect blend of urban convenience and natural beauty at Franklin Commons Apartments, located near Benjamin Rush State Park in Bensalem, PA. Our community ensures you are close to all the outdoor adventure you crave while enjoying modern living.\n\nChoose from spacious one and two-bedroom floor plans, each featuring in-unit washers and dryers and elegant AION renovations. Residents can take advantage of a well-equipped fitness center, engaging community activities, and a dedicated dog park for pet lovers. Benjamin Rush State Park is just a short distance away, providing abundant opportunities for hiking, cycling, and enjoying the great outdoors. Experience the best of both worlds at Franklin Commons—schedule a visit today to see your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bensalem Apartments Near Benjamin Rush Park",
      "seo_description": "Franklin Commons in Bensalem offers modern apartments close to Benjamin Rush State Park, combining outdoor adventure with contemporary living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "silver-lake-nature-center-near-franklin-commons-apartments-29",
      "search_query": "Silver Lake Nature Center close to Franklin Commons Apartments",
      "category": "Park",
      "h1_title": "Franklin Commons Near Silver Lake Nature Center",
      "h2_subtitle": "Explore the best of nature and modern living at Franklin Commons Apartments, close to the serene Silver Lake Nature Center in Bensalem.",
      "page_copy": "Nestled in Bensalem, PA, Franklin Commons Apartments offers a unique living experience with proximity to the Silver Lake Nature Center. This perfect location provides easy access to nature while ensuring the comforts of modern living at home.\n\nOur community offers one and two-bedroom floor plans, thoughtfully designed with in-unit washers and dryers and contemporary AION renovations. Residents enjoy amenities such as a vibrant fitness center, an active schedule of community events, and a welcoming dog park. Silver Lake Nature Center is just a short distance away, offering ample opportunities for bird watching, hiking, and educational programs. Choose Franklin Commons Apartments for a harmonious blend of tranquility and community. Visit today and find your perfect spot!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Franklin Commons Near Silver Lake Nature Center",
      "seo_description": "Franklin Commons in Bensalem is close to Silver Lake Nature Center, offering a lifestyle where nature meets modern living through ideal amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "apartments-near-philadelphia-international-airport-bensalem-690",
      "search_query": "apartments near philadelphia international airport bensalem",
      "category": "Transit",
      "h1_title": "Bensalem Apartments Near Philadelphia Airport",
      "h2_subtitle": "Franklin Commons offers convenient living near Philadelphia International Airport, combining ease of travel with modern amenities in Bensalem.",
      "page_copy": "Franklin Commons Apartments in Bensalem, PA, is the ideal choice for those seeking proximity to Philadelphia International Airport. Enjoy the convenience of quick access to the airport while living in a vibrant community setting.\n\nOur one and two-bedroom floor plans boast modern touches, including in-unit washers and dryers and elegant AION renovations. Residents can take advantage of a fitness center, engaging community activities, and a serene dog park, all designed to enhance your living experience. With its convenient location near Philadelphia International Airport, Franklin Commons Apartments perfectly suits frequent flyers and those who desire seamless travel options. Experience the best of convenience and comfort by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
      "featured_image_media": {
        "alt_text": "Patio area with fire pits and chairs under string lights at dusk.",
        "public_id": "01a015d9-e47f-77d5-a5c1-0bbd92283bd6",
        "storage_key": "property/6767906449166317/01a015d9-e47f-77d5-a5c1-0bbd92283bd6.webp",
        "width": 3072,
        "height": 2050
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bensalem Apartments Near Philadelphia Airport",
      "seo_description": "Franklin Commons offers modern living in Bensalem, with apartments conveniently located near Philadelphia International Airport.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166317",
      "source": "custom",
      "page_item_url": "bensalem-pa-apartments-for-rent",
      "search_query": "Apartments for Rent in Bensalem PA",
      "category": "false",
      "h1_title": "Apartments for Rent in Bensalem PA",
      "h2_subtitle": "Discover stunning apartments for rent in Bensalem, PA. Franklin Commons offers modern living with exceptional amenities.",
      "page_copy": "Looking for apartments for rent in Bensalem, PA? Franklin Commons Apartments offers renovated one- and two-bedroom apartment homes at 1400 Cardinal Dr in Bucks County, each with a private entrance and a private balcony or patio.\n\nResidents enjoy a swimming pool with sundeck, fitness center, clubhouse, dog park, and package lockers, plus free off-street parking and a bilingual site team. Our pet-friendly community welcomes your four-legged family members.\nSpend weekends at Neshaminy State Park, shop at Neshaminy Mall, and explore everything Bensalem has to offer. View our floor plans and schedule a tour of your new home in Bensalem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166317/01a11c84-f0fc-72b9-b20c-eb6f5c7a93f5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor seating area with fire pits and string lights at dusk.",
        "public_id": "01a11c84-f0fc-72b9-b20c-eb6f5c7a93f5",
        "storage_key": "property/6767906449166317/01a11c84-f0fc-72b9-b20c-eb6f5c7a93f5.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments for Rent in Bensalem PA",
      "seo_description": "Find modern apartments for rent in Bensalem, PA at Franklin Commons. Stylish floor plans and excellent amenities await. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5055"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976243548"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973276"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WW3M8VFM"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livefranklincommons.fatwin.com/api/websites/resources/1?x=eUNXY1VlalI3ZXNtNGZsTzFjUVkzRVJQeUpycDNIYkZvMzVianhqT1J6U2s5ekZGK0lTRnpvaDV3TTQrQ2xpUjZDUld5VWFwTi9mczhFTzBqV0xpN2c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Stadium House"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549e1f6-43e6-11ef-860d-0fa86da0ac4c"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549e1f6-43e6-11ef-860d-0fa86da0ac4c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549e1f6-43e6-11ef-860d-0fa86da0ac4c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImxMbzZoOHF3bi9oTzBOMW5iMnJEVlE9PSIsInZhbHVlIjoiMTZyMkdacDlIMDh3N2xWc0hwY08xQT09IiwibWFjIjoiMzEyM2I4NjJhODcyZGE1MzQzMDRlZjhhOGI1YTExZjAzOTI3MDI4YmM0ODI2MmZhMTQ2ZTQ1MTYwYjZmOTc3YSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5055",
  "custom_repli_id": "9976243548",
  "custom_realpage_id": "4973276",
  "custom_google_gtm_id": "GTM-WW3M8VFM",
  "custom_perq_script_url": "https://livefranklincommons.fatwin.com/api/websites/resources/1?x=eUNXY1VlalI3ZXNtNGZsTzFjUVkzRVJQeUpycDNIYkZvMzVianhqT1J6U2s5ekZGK0lTRnpvaDV3TTQrQ2xpUjZDUld5VWFwTi9mczhFTzBqV0xpN2c9PQ2",
  "custom_vibesites_theme": "Stadium House",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549e1f6-43e6-11ef-860d-0fa86da0ac4c",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549e1f6-43e6-11ef-860d-0fa86da0ac4c/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549e1f6-43e6-11ef-860d-0fa86da0ac4c/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImxMbzZoOHF3bi9oTzBOMW5iMnJEVlE9PSIsInZhbHVlIjoiMTZyMkdacDlIMDh3N2xWc0hwY08xQT09IiwibWFjIjoiMzEyM2I4NjJhODcyZGE1MzQzMDRlZjhhOGI1YTExZjAzOTI3MDI4YmM0ODI2MmZhMTQ2ZTQ1MTYwYjZmOTc3YSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "d2d1f222-3e0d-486a-9cef-04d086675aed",
  "custom_audioeye_site_hash": "f7dfe67441e5f77921cbbe12d8bf8df9"
};

export const generatedAt = '2026-11-03T22:47:42.485Z';
